import { $ } from "@/plug/Axios";

export default {
  /**
   * 教务岗位绩效考核
   */
  appraisalEmployee_appraise: {
    /*
     * 上级评分
     * content json, itemId|score|reason (string query required)
     * flowId 审批节点id (integer query required)
     * id id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/appraisalEmployee/appraise", p, c)
  },
  appraisalEmployee_detail: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/education/appraisalEmployee/detail", p, c)
  },
  appraisalEmployee_export: {
    /*
     * 导出-学历教育-评分与绩效-岗位绩效
     */
    get: (p, c) => $.get("/api/ems/education/appraisalEmployee/export", p, c)
  },
  appraisalEmployee_init: {
    /*
     * 生成考核数据或单个添加考核人
     * adminId adminId, 单个添加的时候用 (integer query )
     * month 月 (integer query required)
     * year 年 (integer query required)
     */
    post: (p, c) => $.post("/api/ems/education/appraisalEmployee/init", p, c)
  },
  appraisalEmployee_listForAudit: {
    /*
     * 列表-学历教育-评分与绩效-岗位绩效审核
     */
    get: (p, c) =>
      $.get("/api/ems/education/appraisalEmployee/listForAudit", p, c)
  },
  appraisalEmployee_listPage: {
    /*
     * 列表-学历教育-评分与绩效-岗位绩效
     */
    get: (p, c) => $.get("/api/ems/education/appraisalEmployee/listPage", p, c)
  },
  appraisalEmployee_remove: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/education/appraisalEmployee/remove", p, c)
  },

  /**
   * 修改转介绍信息
   */
  changeReferral_apply: {
    /*
     * 申请
     * dingDepartmentId 钉钉部门id (integer query required)
     * referralUserId 推荐人id (integer query required)
     * remark 备注 (string query required)
     * schoolRollId 学籍id (integer query required)
     */
    post: (p, c) => $.post("/api/ems/education/changeReferral/apply", p, c)
  },
  changeReferral_listBySchoolRollId: {
    /*
     * 当前合同下的修改转介绍记录列表
     * schoolRollId 学籍id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/changeReferral/listBySchoolRollId", p, c)
  },
  changeReferral_sync: {
    /*
     * 同步
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/education/changeReferral/sync", p, c)
  },

  /**
   * 教务通知
   */
  educationNotice_addReceiver: {
    /*
     * 添加收件人
     * copyReceiverIds 抄送人列表 (array query required)
     * id id (integer query required)
     * receiverIds 收件人列表 (array query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/educationNotice/addReceiver", p, c)
  },
  educationNotice_autoUpdateDelayStatus: {
    /*
     * 临时方法-更新即将逾期和逾期未完成
     */
    put: (p, c) =>
      $.put("/api/ems/education/educationNotice/autoUpdateDelayStatus", p, c)
  },
  educationNotice_countSelfUnFinished: {
    /*
     * 首页通知未完成数量
     */
    get: (p, c) =>
      $.get("/api/ems/education/educationNotice/countSelfUnFinished", p, c)
  },
  educationNotice_delay: {
    /*
     * 延长截止时间
     * deadline 截止日期 (string query required)
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/education/educationNotice/delay", p, c)
  },
  educationNotice_detail: {
    /*
     * 详情
     * fromService 来源：1内部管理-教务通知详情 2通知投诉-通知管理详情 3通知投诉-通知收件详情详情 (integer query required)
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/education/educationNotice/detail", p, c)
  },
  educationNotice_downloadMould: {
    /*
     * 下载模板
     */
    get: (p, c) =>
      $.get("/api/ems/education/educationNotice/downloadMould", p, c)
  },
  educationNotice_finish: {
    /*
     * 标记完成
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/education/educationNotice/finish", p, c)
  },
  educationNotice_headerTeacherConfirm: {
    /*
     * 班主任确认通知
     * extraUrl 附件地址 (string query )
     * recordId 详情返回的recordId, 没有则不需要确认 (integer query required)
     * remark 备注 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/educationNotice/headerTeacherConfirm", p, c)
  },
  educationNotice_list: {
    /*
     * 列表(学历教育-通知投诉-通知管理)
     */
    get: (p, c) => $.get("/api/ems/education/educationNotice/list", p, c)
  },
  educationNotice_listConfirm: {
    /*
     * 班主任确认记录
     * recordId 详情返回的recordId (integer query required)
     */
    get: (p, c) => $.get("/api/ems/education/educationNotice/listConfirm", p, c)
  },
  educationNotice_listForCreator: {
    /*
     * APP端-创建人登陆获取列表
     * belong belong (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/educationNotice/listForCreator", p, c)
  },
  educationNotice_listForCreatorReceiver: {
    /*
     * 创建通知时查询收件人列表-自考直接取所有管理员列表
     * info Json串，可多个 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/educationNotice/listForCreatorReceiver", p, c)
  },
  educationNotice_listForEdu: {
    /*
     * 列表(学历教育-通知投诉-通知收件详情)
     */
    get: (p, c) => $.get("/api/ems/education/educationNotice/listForEdu", p, c)
  },
  educationNotice_listForSelf: {
    /*
     * 列表(基础平台-内部管理-教务通知)
     */
    get: (p, c) => $.get("/api/ems/education/educationNotice/listForSelf", p, c)
  },
  educationNotice_listForSelfTaught: {
    /*
     * 列表(自考平台-通知投诉-通知管理)
     */
    get: (p, c) =>
      $.get("/api/ems/education/educationNotice/listForSelfTaught", p, c)
  },
  educationNotice_listReceiver: {
    /*
     * 详情里的收件人列表
     * departmentName 部门 (string query )
     * noticeId 通知id (integer query required)
     * receiverName 姓名 (string query )
     * roleType 角色：收件人|抄送人 (string query )
     * status 状态：未查看|已查看|完成 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/educationNotice/listReceiver", p, c)
  },
  educationNotice_listSelfTaughtForEdu: {
    /*
     * 列表(自考平台-通知投诉-通知收件详情)
     */
    get: (p, c) =>
      $.get("/api/ems/education/educationNotice/listSelfTaughtForEdu", p, c)
  },
  educationNotice_listSimpleCreator: {
    /*
     * 简单通知创建人列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/educationNotice/listSimpleCreator", p, c)
  },
  educationNotice_listSimpleReceiver: {
    /*
     * 简单通知抄送人|接收人列表
     * noticeId 通知id， 查询发件人不传 (integer query )
     * roleType 收件人|抄送人 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/educationNotice/listSimpleReceiver", p, c)
  },
  educationNotice_publish: {
    /*
     * 发布通知
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/education/educationNotice/publish", p, c)
  },
  educationNotice_refuse: {
    /*
     * 教务打回通知
     * recordId 详情返回的recordId (integer query required)
     * remark 打回理由 (string query )
     */
    put: (p, c) => $.put("/api/ems/education/educationNotice/refuse", p, c)
  },
  educationNotice_remove: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/education/educationNotice/remove", p, c)
  },
  educationNotice_save: {
    /*
     * 添加
     * attachmentUrl 附件地址，可多个 (string query )
     * batches 批次，多选逗号隔开 (string query required)
     * belong 分类 (string query required)
     * category 类别：政策公告(直接确认即)、事务通知(需完成) (string query required)
     * classify 分类：招办、学籍、考务、教学，其他可多选 (string query required)
     * content 内容 (string query required)
     * deadline 截止日期 (string query required)
     * remindTime 截止日期前未完成钉钉提醒时间 (string query required)
     * siteInfo 学校，多选 (string query )
     * title 标题 (string query required)
     */
    post: (p, c) => $.post("/api/ems/education/educationNotice/save", p, c)
  },
  educationNotice_searchByCopyReceiverList: {
    /*
     * 根据抄送人筛选返回收件人和抄送人列表
     * copyReceiverIds 抄送人列表 (array query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/educationNotice/searchByCopyReceiverList", p, c)
  },
  educationNotice_sendDingNotice: {
    /*
     * 手动发送通知提醒
     * content 内容 (string query required)
     * id id (integer query required)
     * statuses 收件人状态：未完成、已完成、按时完成、即将逾期、逾期已完成、逾期未完成 (array query required)
     * title 标题 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/educationNotice/sendDingNotice", p, c)
  },
  educationNotice_update: {
    /*
     * 编辑
     * attachmentUrl 附件地址，可多个 (string query )
     * batches 批次，多选逗号隔开 (string query required)
     * category 类别：政策公告(直接确认即)、事务通知(需完成) (string query required)
     * classify 分类：招办、学籍、考务、教学，其他可多选 (string query required)
     * content 内容 (string query required)
     * deadline 截止日期 (string query required)
     * id id (integer query required)
     * remindTime 截止日期前未完成钉钉提醒时间 (string query required)
     * siteInfo 学校，多选 (string query )
     * title 标题 (string query required)
     */
    put: (p, c) => $.put("/api/ems/education/educationNotice/update", p, c)
  },
  educationNotice_upload: {
    /*
     * 导入筛选收件人
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/education/educationNotice/upload", p, c)
  },

  /**
   * 毕业管理-自考
   */
  graduate_autoCheckPreviewGraduate: {
    /*
     * 临时方法-大于8门课程成绩合格的,置为预毕业
     */
    post: (p, c) =>
      $.post("/api/ems/education/graduate/autoCheckPreviewGraduate", p, c)
  },
  graduate_exportForSelfTaught: {
    /*
     * 毕业学生-导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/graduate/exportForSelfTaught", p, c)
  },
  graduate_exportPreviewForSelfTaught: {
    /*
     * 预毕业-导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/graduate/exportPreviewForSelfTaught", p, c)
  },
  graduate_listForSelfTaught: {
    /*
     * 毕业学生-列表
     */
    get: (p, c) => $.get("/api/ems/education/graduate/listForSelfTaught", p, c)
  },
  graduate_listPreviewForSelfTaught: {
    /*
     * 预毕业-列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/graduate/listPreviewForSelfTaught", p, c)
  },
  graduate_uploadDiploma: {
    /*
     * 批量导入毕业证-毕业学生
     * id id (integer query required)
     * url url (string query required)
     */
    post: (p, c) => $.post("/api/ems/education/graduate/uploadDiploma", p, c)
  },
  graduate_uploadRegister: {
    /*
     * 批量导入自考电子注册备案表(学信网截图)-毕业学生
     * id id (integer query required)
     * url url (string query required)
     */
    post: (p, c) => $.post("/api/ems/education/graduate/uploadRegister", p, c)
  },
  graduate_uploadRegisterUrl: {
    /*
     * 导入毕业登记表-预毕业
     * id id (integer query required)
     * url url (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/graduate/uploadRegisterUrl", p, c)
  },

  /**
   * 在线承诺书签署
   */
  online_signature: {
    /*
     * 添加编辑
     * endTime 结束时间 (string query )
     * id  (integer query )
     * name 名称 (string query )
     * startTime 开始时间 (string query )
     * templateUrl 模块地址 (string query )
     * type 类型: 理工导师承诺书 (string query )
     */
    post: (p, c) => $.post("/api/ems/education/online/signature", p, c),

    /*
     * 删除
     * id Id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/education/online/signature", p, c)
  },
  online_signature_exportRecord: {
    /*
     * 导出记录
     * id Id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/online/signature/exportRecord", p, c)
  },
  online_signature_getInfo: {
    /*
     * 根据类型获取签署内容
     * id Id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/education/online/signature/getInfo", p, c)
  },
  online_signature_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/education/online/signature/list", p, c)
  },
  online_signature_listRecord: {
    /*
     * 记录列表
     * id Id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/education/online/signature/listRecord", p, c)
  },
  online_signature_removeRecord: {
    /*
     * 删除记录
     * ids 记录Ids (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/education/online/signature/removeRecord", p, c)
  },
  online_signature_uploadSignature: {
    /*
     * C端上传签署书（签名）
     * id Id (integer query required)
     * signData 签名图片，png文件，base64值 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/online/signature/uploadSignature", p, c)
  },

  /**
   * 学生报名信息
   */
  peer_analysisLearnForm: {
    /*
     * 解析学习形式
     * adultExamYear 成考年度 (string query )
     * batch 批次 (string query )
     * level 专业层次 (string query )
     * major 专业 (string query )
     * rollGrade 学籍年级 (string query )
     * schoolStatuses 学籍状态 (array query )
     * site 学校 (string query )
     * siteType 学校类型 (string query )
     */
    get: (p, c) => $.get("/api/ems/education/peer/analysisLearnForm", p, c)
  },
  peer_batchUpdatePeerStudent: {
    /*
     * 批量编辑
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/peer/batchUpdatePeerStudent", p, c)
  },
  peer_details: {
    /*
     * 前端学籍合同详情（报名确认、招生统计、招办审核）
     * id id (integer query )
     */
    get: (p, c) => $.get("/api/ems/education/peer/details", p, c)
  },
  peer_downloadBatchChangeMajorMould: {
    /*
     * 批量导入更换批次专业模板
     */
    get: (p, c) =>
      $.get("/api/ems/education/peer/downloadBatchChangeMajorMould", p, c)
  },
  peer_downloadBatchUpdatePeerStudentMould: {
    /*
     * 批量编辑模版
     */
    get: (p, c) =>
      $.get("/api/ems/education/peer/downloadBatchUpdatePeerStudentMould", p, c)
  },
  peer_downloadPeerStudentMould: {
    /*
     * 批量代报模版
     */
    get: (p, c) =>
      $.get("/api/ems/education/peer/downloadPeerStudentMould", p, c)
  },
  peer_downloadUpdateAdultInfo: {
    /*
     * 批量更新成考信息模板
     */
    get: (p, c) =>
      $.get("/api/ems/education/peer/downloadUpdateAdultInfo", p, c)
  },
  peer_downloadUpdateServiceMould: {
    /*
     * 批量导入更新服务信息模板
     */
    get: (p, c) =>
      $.get("/api/ems/education/peer/downloadUpdateServiceMould", p, c)
  },
  peer_enroll: {
    /*
     * 报名
     * batch 批次 (string query required)
     * enrollLevel 报名层次（包含专升本） (string query required)
     * idCardNo 身份证 (string query required)
     * majorId 专业id (integer query required)
     * name 真实姓名 (string query required)
     */
    post: (p, c) => $.post("/api/ems/education/peer/enroll", p, c)
  },
  peer_exportForEnrollConfirm: {
    /*
     * 报名确认列表导出
     */
    get: (p, c) => $.get("/api/ems/education/peer/exportForEnrollConfirm", p, c)
  },
  peer_listForEnrollConfirm: {
    /*
     * 报名确认列表
     */
    get: (p, c) => $.get("/api/ems/education/peer/listForEnrollConfirm", p, c)
  },
  peer_pass: {
    /*
     * 招生老师通过
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/education/peer/pass", p, c)
  },
  peer_updateForFront: {
    /*
     * 招生老师编辑
     * addScoreItem 加分项 (string query )
     * address 身份证地址 (string query )
     * adultExamArea 成考考区 (string query )
     * adultExamCity 成考地级市 (string query )
     * birth 出生日期 (string query )
     * campus 期末考区 (string query )
     * certificatePhoto 特殊证件 (string query )
     * contactPhone 联系电话 (string query )
     * diplomaNo 毕业证书编号 (string query )
     * diplomaPhoto 毕业证照片 (string query )
     * educationLevel 毕业层次 (string query )
     * educationNetCertificateInfo 学信网零散查询 (string query )
     * educationNetCertificateNo 备案表在线验证码 (string query )
     * emergencyContactName 紧急联系人 (string query )
     * emergencyContactPhone 紧急联系电话 (string query )
     * gender 性别 (string query )
     * graduationMajor 毕业专业 (string query )
     * graduationSchool 毕业院校 (string query )
     * graduationTime 毕业时间 (string query )
     * id 学籍信息id (integer query )
     * idCardBackPhoto 身份证反面 (string query )
     * idCardFrontPhoto 身份证正面 (string query )
     * idCardNo 身份证号 (string query )
     * localType 成考所在地类型 (string query )
     * name 姓名 (string query )
     * nation 民族 (string query )
     * natives 是否省内（继教院隐藏） (string query )
     * notNeedExamItem 免试项 (string query )
     * photo 个人照 (string query )
     */
    put: (p, c) => $.put("/api/ems/education/peer/updateForFront", p, c)
  },
  peer_uploadChangeMajor: {
    /*
     * 批量导入更换批次专业
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/education/peer/uploadChangeMajor", p, c)
  },
  peer_uploadForUpdateService: {
    /*
     * 批量导入更新服务信息
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/peer/uploadForUpdateService", p, c)
  },
  peer_uploadOfficialInfoForPeer: {
    /*
     * 批量更新成考考试院表身份证号关联-仅衢工程
     * excelFile excelFile (file formData required)
     * year 成考年度 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/peer/uploadOfficialInfoForPeer", p, c)
  },
  peer_uploadPeerStudent: {
    /*
     * 批量代报
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/education/peer/uploadPeerStudent", p, c)
  },
  peer_uploadUpdateAdultInfo: {
    /*
     * 批量更新成考信息
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/peer/uploadUpdateAdultInfo", p, c)
  },

  /**
   * 同行通知
   */
  peerNotice_detail: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/education/peerNotice/detail", p, c)
  },
  peerNotice_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/education/peerNotice/export", p, c)
  },
  peerNotice_exportReceiver: {
    /*
     * 导出收件人
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/education/peerNotice/exportReceiver", p, c)
  },
  peerNotice_exportReceiverStudent: {
    /*
     * 导出同行收件人学生列表
     * batch 批次 (string query )
     * id 收件人列表行id， 行后面导出传入 (integer query )
     * noticeId 通知id，详情返回的id (integer query required)
     * rollGrade 学籍年级 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/peerNotice/exportReceiverStudent", p, c)
  },
  peerNotice_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/education/peerNotice/list", p, c)
  },
  peerNotice_listCreator: {
    /*
     * 简单发件人列表
     */
    get: (p, c) => $.get("/api/ems/education/peerNotice/listCreator", p, c)
  },
  peerNotice_listReceiverRecord: {
    /*
     * 查询收件人列表
     * id 行id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/peerNotice/listReceiverRecord", p, c)
  },
  peerNotice_listReceiverStudent: {
    /*
     * 查询同行收件人学生列表
     * batch 批次 (string query )
     * id 收件人列表行id (integer query required)
     * rollGrade 学籍年级 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/peerNotice/listReceiverStudent", p, c)
  },
  peerNotice_listSite: {
    /*
     * 简单发件人学校列表
     */
    get: (p, c) => $.get("/api/ems/education/peerNotice/listSite", p, c)
  },
  peerNotice_remove: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/education/peerNotice/remove", p, c)
  },
  peerNotice_removeReceivers: {
    /*
     * 删除收件人
     * ids ids (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/education/peerNotice/removeReceivers", p, c)
  },
  peerNotice_save: {
    /*
     * 添加编辑
     * attachmentUrl 附件地址，可多个 (string query )
     * batches 批次，多选逗号隔开 (array query required)
     * content 内容 (string query required)
     * id id (integer query )
     * sites 学校，多选逗号隔开 (array query required)
     * theoryPublishTime 应发出时间 (string query required)
     * title 标题 (string query required)
     * type 类型（key同行通知类型） (string query required)
     */
    post: (p, c) => $.post("/api/ems/education/peerNotice/save", p, c)
  },
  peerNotice_updateReceiver: {
    /*
     * 编辑收件信息
     * examEndTime 考试结束时间 (string query )
     * examPaperBackInfo 回卷情况 (string query )
     * examPaperPostFlag 试卷寄出情况（是/否） (string query )
     * examStartTime 考试开始时间 (string query )
     * finishRemark 合作单位反馈 (string query )
     * finishStatus 完成情况（是/否） (string query )
     * finishTime 完成时间 (string query )
     * id id|无||| (integer query )
     * peerNoticeId peerNoticeId|无||| (integer query )
     * receiveTime 接收时间 (string query )
     * receiverId 收件人|筛选||ID下拉|api/ems/education/peerNotice/listCreator (integer query )
     * receiverName 收件人|列表||| (string query )
     * remark 备注 (string query )
     * thesisDegreeApply 论文申请学位情况 (string query )
     * thesisTeacher 论文指导老师 (string query )
     * title 通知标题|全部||| (string query )
     */
    post: (p, c) => $.post("/api/ems/education/peerNotice/updateReceiver", p, c)
  },
  peerNotice_uploadReceiver: {
    /*
     * 导入收件信息
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/education/peerNotice/uploadReceiver", p, c)
  },

  /**
   * 照片采集
   */
  photoCollection: {
    /*
     * 添加编辑
     * areaNo 地区码|列表||| (string query )
     * auditRemark 审核备注|全部||| (string query )
     * auditStatus 审核状态|全部||字符串下拉|api/bms/develop/config/listSelect?key=毕业照片审核状态 (string query )
     * batch 拍摄批次|全部||字符串下拉|api/ems/education/photoCollection/listColumn?column=batch (string query )
     * chsiCollectCode 学信网采集码|列表|图片|| (string query )
     * chsiPhotoUrl 学信网截图|列表|图片|| (string query )
     * classRoom 教室|全部||| (string query )
     * eduRemark 教务备注|全部||| (string query )
     * examNo 考生号|全部||| (string query )
     * feeRefundStatus 照片采集退费状态|全部||字符串下拉|api/bms/develop/config/listSelect?key=照片采集退费状态 (string query )
     * headerTeacher 班主任|列表||| (string query )
     * headerTeacherId 班主任id|筛选||ID下拉|api/bms/system/admin/listAdmin (integer query )
     * headerTeacherRemark 班主任备注|全部||| (string query )
     * id 照片采集编号|全部||| (string query )
     * idCardNo 身份证号|全部||| (string query )
     * level 层次|全部||字符串下拉|api/ems/education/photoCollection/listColumn?column=level (string query )
     * major 专业|列表||| (string query )
     * name 姓名|全部||| (string query )
     * orderNo 订单号|全部||| (string query )
     * payAccount 收款方式|列表||| (string query )
     * payAmount 收款金额|列表||| (number query )
     * payTime 收款时间|全部|时间|时间| (string query )
     * photoAddress 拍摄具体地址|全部||| (string query )
     * photoCampus 拍摄校区|全部||字符串下拉|api/ems/education/photoCollection/listColumn?column=photo_campus (string query )
     * photoChecked 身份核验|全部||字符串下拉|api/bms/develop/config/listSelect?key=是否 (string query )
     * photoDate 拍摄日期|全部|时间|时间| (string query )
     * photoGroup 拍摄分组|全部||| (string query )
     * photoTimePeriod 拍摄具体时间|全部||| (string query )
     * photoUpdateTime 最近更新时间|全部|时间|时间| (string query )
     * photoUrl 照片|列表|图片|| (string query )
     * rollGrade 学籍年级|全部||| (string query )
     * schoolRollId 合同编号|全部||| (string query )
     * schoolStatus 学籍状态|全部||字符串下拉|api/ems/basic/schoolStatus/config/listSchoolStatus (string query )
     * sequenceNo 拍摄序号|无||| (integer query )
     * sequenceNoText 拍摄序号|列表||| (string query )
     * sex 性别|全部||字符串下拉|api/bms/develop/config/listSelect?key=性别 (string query )
     * siteName 学校|全部||字符串下拉|api/ems/education/photoCollection/listColumn?column=site_name (string query )
     * siteNo 院校代码|列表||| (string query )
     * siteType 所在校别|全部||字符串下拉|api/ems/education/photoCollection/listColumn?column=site_type (string query )
     * sourceDetails 来源详情|全部||字符串下拉|api/ems/education/photoCollection/listColumn?column=source_details (string query )
     * studentNo 学号|全部||| (string query )
     * syncRemark 同步备注|全部||字符串下拉|api/ems/education/photoCollection/listColumn?column=sync_remark (string query )
     * syncStatus 合同同步状态|全部||字符串下拉|api/bms/develop/config/listSelect?key=同步状态 (string query )
     */
    post: (p, c) => $.post("/api/ems/education/photoCollection", p, c)
  },
  photoCollection_auditByEducation: {
    /*
     * 教务审核
     * auditStatus 审核状态 (string query required)
     * id 行id (integer query )
     * ids 行ids (array query )
     * remark 审核备注 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/photoCollection/auditByEducation", p, c)
  },
  photoCollection_auditByHeaderTeacher: {
    /*
     * 班主任审核
     * auditStatus 审核状态 (string query required)
     * id 行id (integer query required)
     * remark 审核备注 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/photoCollection/auditByHeaderTeacher", p, c)
  },
  photoCollection_batchRemove: {
    /*
     * 批量删除
     * ids 行id (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/education/photoCollection/batchRemove", p, c)
  },
  photoCollection_batchUpdate: {
    /*
     * 照片采集批量更新
     * batch 拍摄批次 (string query required)
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/photoCollection/batchUpdate", p, c)
  },
  photoCollection_downloadMouldForAudit: {
    /*
     * 下载教务导入审核模板
     */
    get: (p, c) =>
      $.get("/api/ems/education/photoCollection/downloadMouldForAudit", p, c)
  },
  photoCollection_downloadUpdateModule: {
    /*
     * 批量更新模版
     */
    get: (p, c) =>
      $.get("/api/ems/education/photoCollection/downloadUpdateModule", p, c)
  },
  photoCollection_exportForEducation: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/photoCollection/exportForEducation", p, c)
  },
  photoCollection_getAbleBatch: {
    /*
     * 获取启用批次
     */
    get: (p, c) =>
      $.get("/api/ems/education/photoCollection/getAbleBatch", p, c)
  },
  photoCollection_getId: {
    /*
     * 根据身份证和拍摄批次获取学生拍照信息
     * batch 拍照批次 (string query required)
     * idCardNo 身份证 (string query )
     * photoCampus 拍摄小区 (string query required)
     * studentNo 学号 (string query )
     */
    get: (p, c) => $.get("/api/ems/education/photoCollection/getId", p, c)
  },
  photoCollection_getNext: {
    /*
     * 下个学生拍摄信息
     * batch 拍摄批次 (string query required)
     * classRoom 拍摄教室 (string query required)
     * photoCampus 拍摄校区 (string query required)
     * sequenceNo 序号，不传则取序号1的 (integer query )
     */
    get: (p, c) => $.get("/api/ems/education/photoCollection/getNext", p, c)
  },
  photoCollection_getSimple: {
    /*
     * 根据身份证和拍摄批次获取学生拍照信息
     * batch 拍照批次 (string query required)
     * idCardNo 身份证 (string query required)
     * photoCampus 拍摄小区 (string query required)
     */
    get: (p, c) => $.get("/api/ems/education/photoCollection/getSimple", p, c)
  },
  photoCollection_listColumn: {
    /*
     * 字段列表
     * column 列名称 (string query required)
     */
    get: (p, c) => $.get("/api/ems/education/photoCollection/listColumn", p, c)
  },
  photoCollection_listForEducation: {
    /*
     * 教务列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/photoCollection/listForEducation", p, c)
  },
  photoCollection_listForService: {
    /*
     * 服务列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/photoCollection/listForService", p, c)
  },
  photoCollection_saveEduRemark: {
    /*
     * 添加教务备注
     * eduRemark 备注内容 (string query required)
     * id 照片采集id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/photoCollection/saveEduRemark", p, c)
  },
  photoCollection_saveHeaderTeacherRemark: {
    /*
     * 添加班主任备注
     * eduRemark 备注内容 (string query required)
     * id 照片采集id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/photoCollection/saveHeaderTeacherRemark", p, c)
  },
  photoCollection_searchForClient: {
    /*
     * C端查询我的图片采集信息
     */
    get: (p, c) =>
      $.get("/api/ems/education/photoCollection/searchForClient", p, c)
  },
  photoCollection_setAbleBatch: {
    /*
     * 设置启用批次
     * batches 启用批次 (array query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/photoCollection/setAbleBatch", p, c)
  },
  photoCollection_setCampusAndClassRoom: {
    /*
     * 设置拍摄校区和拍摄教室
     * classRoom 照片采集教室 (string query required)
     * id 照片采集id (integer query required)
     * photoCampus 拍摄校区 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/photoCollection/setCampusAndClassRoom", p, c)
  },
  photoCollection_syncSchoolRoll: {
    /*
     * 同步学籍
     */
    post: (p, c) =>
      $.post("/api/ems/education/photoCollection/syncSchoolRoll", p, c)
  },
  photoCollection_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/education/photoCollection/upload", p, c)
  },
  photoCollection_uploadArrange: {
    /*
     * 导入采集安排
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/photoCollection/uploadArrange", p, c)
  },
  photoCollection_uploadChsiPhotoOrCode: {
    /*
     * 导入学信网截图或学信网采集码（前端批量导入，身份证或学号命名）
     * batch 拍摄批次 (string query required)
     * idCardNo 身份证号码或学号 (string query required)
     * type 类型： 1学信网截图 2学信网采集码 (integer query required)
     * url 照片地址 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/photoCollection/uploadChsiPhotoOrCode", p, c)
  },
  photoCollection_uploadEduAdult: {
    /*
     * 教务导入审核
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/photoCollection/uploadEduAdult", p, c)
  },
  photoCollection_uploadPhoto: {
    /*
     * 上传照片
     * chsiCollectCode 学信网采集码 (string query )
     * id 行id (integer query required)
     * photoUrl 照片地址 (string query )
     */
    put: (p, c) => $.put("/api/ems/education/photoCollection/uploadPhoto", p, c)
  },
  photoCollection_uploadPhotoForClient: {
    /*
     * 上传照片
     * chsiCollectCode 学信网采集码 (string query required)
     * id 行id (integer query required)
     * photoUrl 照片地址 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/photoCollection/uploadPhotoForClient", p, c)
  },

  /**
   * 成教预毕业
   */
  previewGraduate_auditGraduate: {
    /*
     * 毕业审核
     * wantGraduateDate 预计毕业时间（每月6月30号） (string query )
     */
    post: (p, c) =>
      $.post("/api/ems/education/previewGraduate/auditGraduate", p, c)
  },
  previewGraduate_checkGraduatePhoto: {
    /*
     * 刷新毕业照片
     * wantGraduateDate 预计毕业时间（每月6月30号） (string query )
     */
    post: (p, c) =>
      $.post("/api/ems/education/previewGraduate/checkGraduatePhoto", p, c)
  },
  previewGraduate_confirmStudyCertificateStatus: {
    /*
     * 批量确认学信网图像
     * ids 行ID列表 (array query required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/previewGraduate/confirmStudyCertificateStatus",
        p,
        c
      )
  },
  previewGraduate_createGraduateInfo: {
    /*
     * 生成预毕业名单
     * siteType 学校类型 (string query required)
     * wantGraduateDate 预计毕业时间（每月6月30号） (string query )
     */
    post: (p, c) =>
      $.post("/api/ems/education/previewGraduate/createGraduateInfo", p, c)
  },
  previewGraduate_downloadThesisScoreMould: {
    /*
     * 下载批量导入论文成绩模版
     */
    get: (p, c) =>
      $.get("/api/ems/education/previewGraduate/downloadThesisScoreMould", p, c)
  },
  previewGraduate_eduAudit: {
    /*
     * 教务审核毕业登记表信息
     * ids id列表 (array query required)
     * reason 通过则填写函授站意见， 拒绝填写理由 (string query )
     * type 类型 1通过 2拒绝 (integer query required)
     */
    put: (p, c) => $.put("/api/ems/education/previewGraduate/eduAudit", p, c)
  },
  previewGraduate_export: {
    /*
     * 毕业审核结论导出-成教
     */
    get: (p, c) => $.get("/api/ems/education/previewGraduate/export", p, c)
  },
  previewGraduate_exportAppendInfo: {
    /*
     * 导出毕业登记表
     * ids 学籍ID列表 (array query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/previewGraduate/exportAppendInfo", p, c)
  },
  previewGraduate_exportAppendInfoForEnterSchool: {
    /*
     * 导出入学登记表
     * createTime 填表时间 (string query required)
     * ids 学籍ID列表 (array query required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/previewGraduate/exportAppendInfoForEnterSchool",
        p,
        c
      )
  },
  previewGraduate_exportGraduateStudent: {
    /*
     * 导出毕业生名册
     * graduateStatus 毕业状态：全部（不传）|未知|预毕业|不毕业 (string query )
     * siteId 学校ID (integer query required)
     * wantGraduateDate 预计毕业时间（每年6月30号） (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/previewGraduate/exportGraduateStudent", p, c)
  },
  previewGraduate_getGraduateAppendInfo: {
    /*
     * 获取毕业登记表信息
     * schoolRollId schoolRollId (integer query )
     * siteType siteType (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/previewGraduate/getGraduateAppendInfo", p, c)
  },
  previewGraduate_getStudentBaseInfoChecking: {
    /*
     * 获取毕业生基本信息
     * schoolRollId 学籍id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/previewGraduate/getStudentBaseInfoChecking",
        p,
        c
      )
  },
  previewGraduate_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/education/previewGraduate/list", p, c)
  },
  previewGraduate_saveGraduateAppendInfoForClient: {
    /*
     * 添加毕业登记表
     * educationLevel 文化程度 (string query )
     * familyAddress 家庭住址 (string query )
     * familyPhone 家庭电话 (string query )
     * formerName 曾用名 (string query )
     * healthInfo 健康状况 (string query )
     * highestLevelTime 入学前最高学历(年月日) (string query )
     * joinPartyInfo 何时何地何人介绍参加共产党员或共青团 (string query )
     * joinWorkTime 参加工作时间 (string query )
     * mainSocialRelations 主要社会关系 (string query )
     * nativePlace 籍贯 (string query )
     * politicalStatus 政治面貌 (string query )
     * postcode 邮编 (string query )
     * rewards 奖惩情况 (string query )
     * selfAppraise 自我鉴定 (string query )
     * selfSignatureUrl 学生签名地址 (string query )
     * siteType siteType (string query required)
     * workDuty 现任职务、职称 (string query )
     * workPlace 工作单位 (string query )
     * workStatus 职业状况(在职或离职) (string query )
     */
    put: (p, c) =>
      $.put(
        "/api/ems/education/previewGraduate/saveGraduateAppendInfoForClient",
        p,
        c
      )
  },
  previewGraduate_teacherAudit: {
    /*
     * 班主任审核毕业登记表
     * ids id列表 (array query required)
     * reason 通过则填写评语， 拒绝填写理由 (string query required)
     * signatureUrl 班主任签名地址 (string query )
     * type 类型 1通过 2拒绝 (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/previewGraduate/teacherAudit", p, c)
  },
  previewGraduate_updateGraduateAppendInfo: {
    /*
     * 编辑毕业登记表
     * educationLevel 文化程度 (string query )
     * familyAddress 家庭住址 (string query )
     * familyPhone 家庭电话 (string query )
     * formerName 曾用名 (string query )
     * healthInfo 健康状况 (string query )
     * highestLevelTime 入学前最高学历(年月日) (string query )
     * id id (integer query required)
     * joinPartyInfo 何时何地何人介绍参加共产党员或共青团 (string query )
     * joinWorkTime 参加工作时间 (string query )
     * mainSocialRelations 主要社会关系 (string query )
     * nativePlace 籍贯 (string query )
     * politicalStatus 政治面貌 (string query )
     * postcode 邮编 (string query )
     * rewards 奖惩情况 (string query )
     * selfAppraise 自我鉴定 (string query )
     * selfSignatureUrl 学生签名地址 (string query )
     * workDuty 现任职务、职称 (string query )
     * workPlace 工作单位 (string query )
     * workStatus 职业状况(在职或离职) (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/previewGraduate/updateGraduateAppendInfo", p, c)
  },
  previewGraduate_updateGraduateAppendInfoForClient: {
    /*
     * 编辑毕业登记表
     * educationLevel 文化程度 (string query )
     * familyAddress 家庭住址 (string query )
     * familyPhone 家庭电话 (string query )
     * formerName 曾用名 (string query )
     * healthInfo 健康状况 (string query )
     * highestLevelTime 入学前最高学历(年月日) (string query )
     * id id (integer query required)
     * joinPartyInfo 何时何地何人介绍参加共产党员或共青团 (string query )
     * joinWorkTime 参加工作时间 (string query )
     * mainSocialRelations 主要社会关系 (string query )
     * nativePlace 籍贯 (string query )
     * politicalStatus 政治面貌 (string query )
     * postcode 邮编 (string query )
     * rewards 奖惩情况 (string query )
     * selfAppraise 自我鉴定 (string query )
     * selfSignatureUrl 学生签名地址 (string query )
     * workDuty 现任职务、职称 (string query )
     * workPlace 工作单位 (string query )
     * workStatus 职业状况(在职或离职) (string query )
     */
    put: (p, c) =>
      $.put(
        "/api/ems/education/previewGraduate/updateGraduateAppendInfoForClient",
        p,
        c
      )
  },
  previewGraduate_updateThesisScore: {
    /*
     * 批量修改论文成绩
     * ids 行ID列表 (array query required)
     * thesisScore 论文成绩（优秀良好不及格等） (string query )
     */
    post: (p, c) =>
      $.post("/api/ems/education/previewGraduate/updateThesisScore", p, c)
  },
  previewGraduate_uploadForExportDetailInfo: {
    /*
     * 按模板导出毕业登记表
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/previewGraduate/uploadForExportDetailInfo",
        p,
        c
      )
  },
  previewGraduate_uploadThesisScore: {
    /*
     * 批量导入论文成绩
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/previewGraduate/uploadThesisScore", p, c)
  },

  /**
   * 学生合同学籍表
   */
  schoolRoll_admissionOrGraduate: {
    /*
     * 录取毕业(人社证书)
     * id 合同id (integer query required)
     * schoolStatus 学籍状态（录取、毕业） (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/admissionOrGraduate", p, c)
  },
  schoolRoll_assignAdminTeacher: {
    /*
     * 分配合同负责人
     * adminTeacherId 合同负责人 (integer query required)
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/assignAdminTeacher", p, c)
  },
  schoolRoll_assignEnrollTeacher: {
    /*
     * 奖励业绩
     * enrollTeacherId 招生老师id (integer query required)
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/assignEnrollTeacher", p, c)
  },
  schoolRoll_autoCheckDelayCommitted: {
    /*
     * 测试-定时任务合同成交超过7天未提交资料
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRoll/autoCheckDelayCommitted", p, c)
  },
  schoolRoll_batchChangeAdminTeacher: {
    /*
     * 批量修改合同负责人
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRoll/batchChangeAdminTeacher", p, c)
  },
  schoolRoll_batchEnrollEducationByContinue: {
    /*
     * 批量成教报名（继教院）
     * batch 批次 (string query required)
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/schoolRoll/batchEnrollEducationByContinue",
        p,
        c
      )
  },
  schoolRoll_batchUpdateEduRemark: {
    /*
     * 批量导入教务备注
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRoll/batchUpdateEduRemark", p, c)
  },
  schoolRoll_batchUpdateForSuspend: {
    /*
     * 批量编辑休学学生
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRoll/batchUpdateForSuspend", p, c)
  },
  schoolRoll_birthdayTodayForFront: {
    /*
     * 当天生日学生数量
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/birthdayTodayForFront", p, c)
  },
  schoolRoll_checkExtraSixtyPayed: {
    /*
     * 临时-查询生成60元提成应发放时间
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/checkExtraSixtyPayed", p, c)
  },
  schoolRoll_countDelayCommitted: {
    /*
     * 成交超7天未提交资料审核
     * batch batch (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/countDelayCommitted", p, c)
  },
  schoolRoll_countForSuspendByEducation: {
    /*
     * 休学学生人数（教务）
     * type 类型:0即将逾期，1已逾期 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/countForSuspendByEducation", p, c)
  },
  schoolRoll_countForSuspendByService: {
    /*
     * 休学学生人数（教务）
     * type 类型:0即将逾期，1已逾期 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/countForSuspendByService", p, c)
  },
  schoolRoll_countOverdueForEnrollStatistics: {
    /*
     * 补齐资料逾期学生数量
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/countOverdueForEnrollStatistics",
        p,
        c
      )
  },
  schoolRoll_countUnFinishForEnrollStatistics: {
    /*
     * 未补齐资料学生数量
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/countUnFinishForEnrollStatistics",
        p,
        c
      )
  },
  schoolRoll_deny: {
    /*
     * 教务拒绝
     * id id (integer query required)
     * reason 拒绝理由 (string query required)
     */
    put: (p, c) => $.put("/api/ems/education/schoolRoll/deny", p, c)
  },
  schoolRoll_detailsForFront: {
    /*
     * 前端学籍合同详情（报名确认、招生统计、招办审核）
     * id id (integer query )
     */
    get: (p, c) => $.get("/api/ems/education/schoolRoll/detailsForFront", p, c)
  },
  schoolRoll_detailsForService: {
    /*
     * 学籍合同详情
     * id id (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/detailsForService", p, c)
  },
  schoolRoll_detailsForServiceByClient: {
    /*
     * 学籍合同详情-企微端获取
     * externalUserId externalUserId (string query required)
     * platform 平台，默认可以不传，中军企微传入中军职达 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/detailsForServiceByClient", p, c)
  },
  schoolRoll_divideEnrollTeacher: {
    /*
     * 划分业绩
     * enrollTeacherId 招生老师id (integer query required)
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/divideEnrollTeacher", p, c)
  },
  schoolRoll_downloadAdminTeacherModule: {
    /*
     * 批量修改合同负责人模板
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/downloadAdminTeacherModule", p, c)
  },
  schoolRoll_downloadMouldForExemptionDegreeSchooling: {
    /*
     * 下载批量导入录取名单模版(免试专升本)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/downloadMouldForExemptionDegreeSchooling",
        p,
        c
      )
  },
  schoolRoll_endSchoolRollByFullPayment: {
    /*
     * 合同完成（缴完全款）
     * id 学籍id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/endSchoolRollByFullPayment", p, c)
  },
  schoolRoll_enrollByCode: {
    /*
     * 通过招生老师二维码代报
     * enrollTeacherCodeId 招生老师二维码ID (integer query required)
     * idCardNo 身份证 (string query )
     * name 姓名 (string query required)
     * phone 手机号 (string query required)
     */
    post: (p, c) => $.post("/api/ems/education/schoolRoll/enrollByCode", p, c)
  },
  schoolRoll_enrollEducationByContinue: {
    /*
     * 成教报名（继教院）
     * area 成考考区 (string query )
     * batch 批次 (string query )
     * campus 期末考区 (string query )
     * city 成考地级市 (string query )
     * continueSchoolRollId 职教合同编号 (string query )
     * diplomaPhoto 毕业证书照片 (string query )
     * domicileArea 户籍地-市 (string query )
     * domicileCity 户籍地-县级市 (string query )
     * educationNetCertificatePhoto 学历电子注册备案表 (string query )
     * emergencyContactName 紧急联系人姓名 (string query )
     * emergencyContactPhone 紧急联系人电话 (string query )
     * enrollLevel 层次 (string query )
     * enrollTeacherId 招生老师（中军报名用） (integer query )
     * major 专业 (string query )
     * majorId 专业id (integer query )
     * natives 是否省内 (string query )
     * phone 手机号（中军报名用） (string query )
     * photo 个人照 (string query )
     * politicalStatus 政治面貌 (string query )
     * shippingAddress 收件地址 (string query )
     * site 学校 (string query )
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRoll/enrollEducationByContinue", p, c)
  },
  schoolRoll_enrollEducationBySelf: {
    /*
     * 自考专本套读
     * batch 合同id (string query required)
     * id 合同id (integer query required)
     * majorId 专业id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRoll/enrollEducationBySelf", p, c)
  },
  schoolRoll_enrollForArmy: {
    /*
     * 军人职业技能报名
     * batch 批次 (string query required)
     * city 安置地（市） (string query required)
     * consultWay 咨询方式 (string query )
     * diplomaPhoto 毕业证书照片 (string query )
     * district 安置地（区县） (string query required)
     * eduLevel 文化程度 (string query )
     * enrollLevel 报名层次 (string query )
     * enrollTeacherId 招生老师id (integer query )
     * familyAddress 家庭住址 (string query )
     * familyContactInfo 家庭联系人及电话 (string query )
     * idCardBackPhoto 身份证背面 (string query )
     * idCardFrontPhoto 身份证正面 (string query )
     * idCardNo 身份证 (string query required)
     * majorId 专业id (integer query required)
     * name 真实姓名 (string query required)
     * originChannel 来源渠道 (string query )
     * originDetail 来源详情 (string query )
     * phone 手机号 (string query required)
     * politicalStatus 政治面貌 (string query )
     * remark 招生备注 (string query )
     * selfPhotoUrl 个人照 (string query )
     */
    post: (p, c) => $.post("/api/ems/education/schoolRoll/enrollForArmy", p, c)
  },
  schoolRoll_enrollForClient: {
    /*
     * C端报名
     * batch 批次 (string query required)
     * consultWay 咨询方式 (string query )
     * enrollLevel 报名层次（包含本科二） (string query required)
     * enrollTeacherId 招生老师id (integer query required)
     * enterpriseQrCodeKey 企业招生二维码 (string query )
     * idCardNo 身份证 (string query required)
     * majorId 专业id (integer query required)
     * name 真实姓名 (string query required)
     * originChannel 来源渠道 (string query )
     * originDetail 来源详情 (string query )
     * phone 手机号 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRoll/enrollForClient", p, c)
  },
  schoolRoll_enrollNew: {
    /*
     * 报名
     * armyProof 退役军人凭证 (string query )
     * armyStatus 是否退役军人 (string query )
     * batch 批次 (string query required)
     * consultWay 咨询方式 (string query )
     * enrollDepartmentId 合同部门, 通过接口取, 有则下拉选择 (integer query )
     * enrollLevel 报名层次（包含专升本） (string query required)
     * enrollTeacherCodeId 招生老师二维码ID (integer query )
     * enrollTeacherId 招生老师id (integer query )
     * enterpriseId 企业id (integer query )
     * extraFile 报名表，学校类型为继教院时显示, 选填 (string query )
     * firstChoiceId 第一志愿(免试专升本) (integer query )
     * idCardNo 身份证 (string query )
     * majorId 专业id (integer query required)
     * name 真实姓名 (string query required)
     * originChannel 来源渠道 (string query )
     * originDetail 来源详情 (string query )
     * phone 手机号 (string query )
     * referralDiscountType 推荐优惠类型(1新老200，2新400 (string query )
     * referralUserId 推荐人ID (integer query )
     * secondChoiceId 第一志愿(免试专升本) (integer query )
     * sourceFrom 来源详情：学校类型为继教院时显示：线上，线下 (string query )
     * sourceFromDetail 具体来源详情：学校类型为继教院且来源详情为线下时显示 (string query )
     * thirdChoiceId 第一志愿(免试专升本) (integer query )
     * userId 用户id (integer query required)
     */
    post: (p, c) => $.post("/api/ems/education/schoolRoll/enrollNew", p, c)
  },
  schoolRoll_exemptionDegree_detailsForFront: {
    /*
     * 前端详情（报名确认、招生统计、招办审核）
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/exemptionDegree/detailsForFront",
        p,
        c
      )
  },
  schoolRoll_exemptionDegree_detailsForService: {
    /*
     * 后端详情
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/exemptionDegree/detailsForService",
        p,
        c
      )
  },
  schoolRoll_exemptionDegree_downloadMouldForAdmission: {
    /*
     * 下载批量导入录取名单模版(免试专升本)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/exemptionDegree/downloadMouldForAdmission",
        p,
        c
      )
  },
  schoolRoll_exemptionDegree_editForFront: {
    /*
     * 前端编辑（报名确认、招生统计、招办审核）
     * address 身份证地址 (string query )
     * adminTeacher 合同负责人 (string query )
     * adminTeacherDepartment 合同负责人部门 (string query )
     * adminTeacherId 合同负责人id (integer query )
     * agreement 协议号 (string query )
     * agreementTime 报读协议签署时间 (string query )
     * agreementUrl 报读协议 (string query )
     * armyAward 个人军功（免试专升本） (string query )
     * armyAwardFileUrl 军功证书（免试专升本） (string query )
     * auditStep 审核情况 (string query )
     * batch 批次 (string query )
     * birth 出生日期 (string query )
     * certificatePhoto 特殊证件(药学护理证件|人社证书的特殊证件) (string query )
     * clueCirculateApplyId 线索流转人id (integer query )
     * clueCirculateApplyName 线索流转人 (string query )
     * clueCreator 线索流转人 (string query )
     * clueCreatorId 线索流转人id (integer query )
     * clueId 线索 (integer query )
     * clueOriginChannel 线索来源渠道 (string query )
     * clueOriginDetail 线索具体来源 (string query )
     * companyAddress 单位地址 (string query )
     * companyName 单位名称 (string query )
     * contactPhone 联系电话 (string query )
     * contractCancelTime 退费时间 (string query )
     * contractFinishTime 成交时间 (string query )
     * contractFinishType 合同成交类型 (string query )
     * denyReason 拒绝原因 (string query )
     * department 合同部门 (string query )
     * departmentId 合同部门id (integer query )
     * diplomaNo 毕业证书编号 (string query )
     * diplomaPhoto 毕业证 (string query )
     * discipline 科类 (string query )
     * discountAmount 优惠金额 (number query )
     * discountType 优惠类型 (string query )
     * eduAuditName 招办老师(如果审核人为空则取学校招办老师字段) (string query )
     * eduAuditTime 招办审核时间 (string query )
     * educationLevel 学历层次 (string query )
     * educationNetCertificatePhoto 学历电子注册备案表（专升本必填） (string query )
     * emergencyContactName 紧急联系人 (string query )
     * emergencyContactPhone 紧急联系电话 (string query )
     * enrollLevel 层次 (string query )
     * enrollRemark 招生老师备注 (string query )
     * enrollTeacher 招生老师 (string query )
     * enrollTeacherDepartment 招生老师部门 (string query )
     * enrollTeacherId 招生老师id (integer query )
     * enrollTeacherPosition 招生老师角色 (string query )
     * enrollTime 报名时间 (string query )
     * enterArmyArea 应征入伍地（免试专升本） (string query )
     * enterArmyTime 入伍时间（免试专升本） (string query )
     * examStudentCategory 考生类别：应届生|非应届生（免试专升本） (string query )
     * firstChoiceId 第一志愿 (integer query )
     * frontAgreementUrl 报读须知 (string query )
     * gender 性别 (string query )
     * graduationDiscipline 毕业科类 (string query )
     * graduationMajor 毕业专业 (string query )
     * graduationSchool 毕业院校 (string query )
     * graduationTime 毕业时间 (string query )
     * headerTeacher 班主任 (string query )
     * headerTeacherId 班主任id (integer query )
     * id 学籍信息id (integer query )
     * idCardBackPhoto 身份证反面 (string query )
     * idCardFrontPhoto 身份证正面 (string query )
     * idCardNo 身份证号 (string query )
     * leaveArmyDomicileArea 退伍安置地（免试专升本） (string query )
     * leaveArmyTime 退伍时间（免试专升本） (string query )
     * liveStatus 流失状态 (string query )
     * loseRiskLevel 流失风险等级 (string query )
     * major 专业 (string query )
     * majorId 专业id (integer query )
     * name 姓名 (string query )
     * nation 民族 (string query )
     * oldSchoolRollId 老合同编号 (integer query )
     * performanceTime 业绩核算时间 (string query )
     * phone 注册手机号 (string query )
     * photo 个人照 (string query )
     * politicalStatus 政治面貌 (string query )
     * preDegreeStatus 前置学历状态 (string query )
     * preHeaderTeacher 前置学历班主任 (string query )
     * preHeaderTeacherPhone 前置学历班主任联系方式 (string query )
     * referralUserId 推荐人id (integer query )
     * referralUserName 推荐人名字 (string query )
     * referralUserPhone 推荐人手机号 (string query )
     * retirementCardPhoto 退役证照片 (string query )
     * schoolStatus 学籍状态 (string query )
     * secondChoiceId 第二志愿 (integer query )
     * shippingAddress 收件地址 (string query )
     * site 学校 (string query )
     * siteId 学校id (integer query )
     * siteProvince 学校省份 (string query )
     * siteType 学校类型 (string query )
     * sourceFrom 来源详情（招生老师角色包含同行招生老师或者招生老师部门包含电销） (string query )
     * sourceFromDetail 具体来源详情 (string query )
     * thirdChoiceId 第三志愿 (integer query )
     * tuitionStatus 缴费状态 (string query )
     * userId 用户id (integer query )
     * workingCertificatePhoto 工作证明对应的凭证） (string query )
     * workingCertificatePhotoType 工作证明|市民卡|社保卡照片的具体类型说明 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/exemptionDegree/editForFront", p, c)
  },
  schoolRoll_exemptionDegree_editForService: {
    /*
     * 后端编辑
     * address 身份证地址 (string query )
     * adminTeacher 合同负责人 (string query )
     * adminTeacherDepartment 合同负责人部门 (string query )
     * adultExamYear 成考年度 (string query )
     * agreement 协议号 (string query )
     * agreementUrl 报读协议 (string query )
     * armyAward 个人军功（免试专升本） (string query )
     * armyAwardFileUrl 军功证书（免试专升本） (string query )
     * auditStep 审核情况 (string query )
     * batch 批次 (string query )
     * birth 出生日期 (string query )
     * classId 班级ID (integer query )
     * classroom 班级 (string query )
     * clueId 线索 (integer query )
     * companyAddress 单位地址 (string query )
     * companyName 单位名称 (string query )
     * contactPhone 联系电话 (string query )
     * contractCancelTime 退费时间 (string query )
     * contractFinishTime 成交时间 (string query )
     * createTime 报名时间 (string query )
     * denyReason 拒绝原因 (string query )
     * department 合同部门 (string query )
     * departmentId 合同部门ID (integer query )
     * diplomaNo 毕业证书编号 (string query )
     * diplomaPhoto 毕业证书照片 (string query )
     * discipline 科类 (string query )
     * discountAmount 优惠金额 (number query )
     * discountType 优惠类型 (string query )
     * eduAuditName 招办老师(如果审核人为空则取学校招办老师字段) (string query )
     * eduAuditTime 招办审核时间 (string query )
     * eduRemark 教务备注 (string query )
     * educationLevel 学历层次 (string query )
     * educationNetCertificatePhoto 学历电子注册备案表（专升本必填） (string query )
     * emergencyContactName 紧急联系人 (string query )
     * emergencyContactPhone 紧急联系电话 (string query )
     * enrollLevel 层次 (string query )
     * enrollRemark 招生老师备注 (string query )
     * enrollTeacher 招生老师 (string query )
     * enrollTeacherDepartment 招生老师部门 (string query )
     * enrollTeacherId 招生老师id (integer query )
     * enrollTeacherPosition 招生老师角色 (string query )
     * enterArmyArea 应征入伍地（免试专升本） (string query )
     * enterArmyTime 入伍时间（免试专升本） (string query )
     * enterprise 校企学生单位（不可编辑，通过企业扫码报名的学生特有） (string query )
     * examStudentCategory 考生类别：应届生|非应届生（免试专升本） (string query )
     * firstChoiceId 第一志愿 (integer query )
     * frontAgreementUrl 报读须知 (string query )
     * gender 性别 (string query )
     * graduationDiscipline 毕业科类 (string query )
     * graduationMajor 毕业专业 (string query )
     * graduationSchool 毕业院校 (string query )
     * graduationTime 毕业时间 (string query )
     * headerTeacher 班主任 (string query )
     * headerTeacherId 班主任id (integer query )
     * id 学籍信息id (integer query )
     * idCardBackPhoto 身份证反面 (string query )
     * idCardFrontPhoto 身份证正面 (string query )
     * idCardNo 身份证号 (string query )
     * leaveArmyDomicileArea 退伍安置地（免试专升本） (string query )
     * leaveArmyTime 退伍时间（免试专升本） (string query )
     * liveStatus 流失状态 (string query )
     * loseRiskLevel 流失风险等级 (string query )
     * major 专业 (string query )
     * majorId 专业id (integer query )
     * name 姓名 (string query )
     * nation 民族 (string query )
     * oldSchoolRollId 老合同编号 (integer query )
     * performanceTime 业绩核算时间 (string query )
     * phone 注册手机号 (string query )
     * photo 个人照 (string query )
     * referralUserId 推荐人id (integer query )
     * referralUserName 推荐人名字 (string query )
     * referralUserPhone 推荐人手机号 (string query )
     * retirementCardPhoto 退役证照片 (string query )
     * rollGrade 学籍年级 (string query )
     * schoolStatus 学籍状态 (string query )
     * secondChoiceId 第二志愿 (integer query )
     * serviceRemark 服务备注 (string query )
     * shippingAddress 收件地址 (string query )
     * site 学校 (string query )
     * siteId 学校id (integer query )
     * siteProvince 学校省份 (string query )
     * siteType 学校类型 (string query )
     * sourceFrom 来源详情（招生老师角色包含同行招生老师或者招生老师部门包含电销） (string query )
     * thirdChoiceId 第三志愿 (integer query )
     * tuitionStatus 缴费状态 (string query )
     * userId 用户id (integer query )
     * workingCertificatePhoto 工作证明 (string query )
     * workingCertificatePhotoType 工作证明等照片的具体类型说明 (string query )
     */
    put: (p, c) =>
      $.put(
        "/api/ems/education/schoolRoll/exemptionDegree/editForService",
        p,
        c
      )
  },
  schoolRoll_exemptionDegree_exportForAudit: {
    /*
     * 招办审核导出
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/exemptionDegree/exportForAudit",
        p,
        c
      )
  },
  schoolRoll_exemptionDegree_exportForService: {
    /*
     * 服务学生列表导出
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/exemptionDegree/exportForService",
        p,
        c
      )
  },
  schoolRoll_exemptionDegree_listForAudit: {
    /*
     * 招办审核列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/exemptionDegree/listForAudit", p, c)
  },
  schoolRoll_exemptionDegree_listForService: {
    /*
     * 服务学生列表
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/exemptionDegree/listForService",
        p,
        c
      )
  },
  schoolRoll_exemptionDegree_listUnAssign: {
    /*
     * 未分配学生列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/exemptionDegree/listUnAssign", p, c)
  },
  schoolRoll_exemptionDegree_uploadAdmission: {
    /*
     * 批量导入录取名单
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/schoolRoll/exemptionDegree/uploadAdmission",
        p,
        c
      )
  },
  schoolRoll_exportCertificateForEducationConfirm: {
    /*
     * 资料审核列表导出
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/exportCertificateForEducationConfirm",
        p,
        c
      )
  },
  schoolRoll_exportExemptionDegreeForEducationConfirm: {
    /*
     * 资料审核列表导出（免试专升本）
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/exportExemptionDegreeForEducationConfirm",
        p,
        c
      )
  },
  schoolRoll_exportForDepartmentEnroll: {
    /*
     * 部门合同列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/exportForDepartmentEnroll", p, c)
  },
  schoolRoll_exportForEnrollStatistics: {
    /*
     * 招生统计列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/exportForEnrollStatistics", p, c)
  },
  schoolRoll_exportForNetClue: {
    /*
     * 网络合同列表导出
     */
    get: (p, c) => $.get("/api/ems/education/schoolRoll/exportForNetClue", p, c)
  },
  schoolRoll_exportForSuspend: {
    /*
     * 休学学生列表导出
     */
    get: (p, c) => $.get("/api/ems/education/schoolRoll/exportForSuspend", p, c)
  },
  schoolRoll_getAgreementInfo: {
    /*
     * 获取正式报读须知内容
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/education/schoolRoll/getAgreementInfo", p, c)
  },
  schoolRoll_getBeijingConfirmInfo: {
    /*
     * 获取北开确认书内容
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/getBeijingConfirmInfo", p, c)
  },
  schoolRoll_getFrontAgreementInfo: {
    /*
     * 获取录取前报读须知内容
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/getFrontAgreementInfo", p, c)
  },
  schoolRoll_getOtherSchoolRollId: {
    /*
     * 查询其他合同数量列表
     * schoolRollId schoolRollId (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/getOtherSchoolRollId", p, c)
  },
  schoolRoll_getSchoolRollIdByPhoneAndBatch: {
    /*
     * 根据手机号和批次获取学籍id
     * batch 批次 (string query required)
     * phone 手机号 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/getSchoolRollIdByPhoneAndBatch",
        p,
        c
      )
  },
  schoolRoll_graduateCheck: {
    /*
     * 添加
     * endTime 结束时间 (string query )
     * id  (integer query )
     * name 名称 (string query )
     * publishStatus 发布状态 (string query )
     * siteId 学校 (integer query )
     * startTime 开始时间 (string query )
     */
    post: (p, c) => $.post("/api/ems/education/schoolRoll/graduateCheck", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/education/schoolRoll/graduateCheck", p, c)
  },
  schoolRoll_graduateCheck_confirm: {
    /*
     * 确认
     * id id (integer query required)
     * remark 选确认有误时, 填写有误内容说明 (string query required)
     * status 状态, 确认有误,确认无误 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRoll/graduateCheck/confirm", p, c)
  },
  schoolRoll_graduateCheck_confirmForClient: {
    /*
     * c端确认
     * id id (integer query required)
     * remark 选确认有误时, 填写有误内容说明 (string query required)
     * status 状态, 确认有误,确认无误 (string query required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/schoolRoll/graduateCheck/confirmForClient",
        p,
        c
      )
  },
  schoolRoll_graduateCheck_downloadMould: {
    /*
     * 下载导入学生模板
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/graduateCheck/downloadMould", p, c)
  },
  schoolRoll_graduateCheck_exportDetail: {
    /*
     * 导出详情列表-教学教务
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/graduateCheck/exportDetail", p, c)
  },
  schoolRoll_graduateCheck_exportDetailForService: {
    /*
     * 导出详情列表-服务管理
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/graduateCheck/exportDetailForService",
        p,
        c
      )
  },
  schoolRoll_graduateCheck_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/graduateCheck/list", p, c)
  },
  schoolRoll_graduateCheck_listDetail: {
    /*
     * 核对详情列表-教学教务
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/graduateCheck/listDetail", p, c)
  },
  schoolRoll_graduateCheck_listDetailForService: {
    /*
     * 核对详情列表-服务管理
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/graduateCheck/listDetailForService",
        p,
        c
      )
  },
  schoolRoll_graduateCheck_listForClient: {
    /*
     * c端, 查询毕业信息核对列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/graduateCheck/listForClient", p, c)
  },
  schoolRoll_graduateCheck_listSimple: {
    /*
     * 简易毕业信息核对列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/graduateCheck/listSimple", p, c)
  },
  schoolRoll_graduateCheck_publish: {
    /*
     * 发布
     * id id (integer query required)
     * publishStatus 状态 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRoll/graduateCheck/publish", p, c)
  },
  schoolRoll_graduateCheck_removeDetail: {
    /*
     * 删除学生
     * ids ids (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/education/schoolRoll/graduateCheck/removeDetail", p, c)
  },
  schoolRoll_graduateCheck_upload: {
    /*
     * 导入学生
     * excelFile excelFile (file formData required)
     * id id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRoll/graduateCheck/upload", p, c)
  },
  schoolRoll_listAdminRemark: {
    /*
     * 负责人备注列表
     * id 合同id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/education/schoolRoll/listAdminRemark", p, c)
  },
  schoolRoll_listCertificateForEducationConfirm: {
    /*
     * 资料审核列表
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/listCertificateForEducationConfirm",
        p,
        c
      )
  },
  schoolRoll_listEnrollInfo: {
    /*
     * 获取学生报名信息
     * idCardNo 身份证 (string query )
     * name 姓名 (string query )
     * phone 手机 (string query )
     * siteType 学校类型 (string query )
     */
    get: (p, c) => $.get("/api/ems/education/schoolRoll/listEnrollInfo", p, c)
  },
  schoolRoll_listExemptionDegreeForEducationConfirm: {
    /*
     * 资料审核列表（免试专升本）
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/listExemptionDegreeForEducationConfirm",
        p,
        c
      )
  },
  schoolRoll_listForDepartmentEnroll: {
    /*
     * 部门合同列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/listForDepartmentEnroll", p, c)
  },
  schoolRoll_listForEnrollConfirm: {
    /*
     * 报名确认列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/listForEnrollConfirm", p, c)
  },
  schoolRoll_listForEnrollStatistics: {
    /*
     * 招生统计列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/listForEnrollStatistics", p, c)
  },
  schoolRoll_listForNetClue: {
    /*
     * 网络合同列表
     */
    get: (p, c) => $.get("/api/ems/education/schoolRoll/listForNetClue", p, c)
  },
  schoolRoll_listForSuspendByEducation: {
    /*
     * 休学学生列表（教务）
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/listForSuspendByEducation", p, c)
  },
  schoolRoll_listForSuspendByService: {
    /*
     * 休学学生列表（服务）
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/listForSuspendByService", p, c)
  },
  schoolRoll_listOldStudent: {
    /*
     * 老生列表
     * name 名字 (string query required)
     */
    get: (p, c) => $.get("/api/ems/education/schoolRoll/listOldStudent", p, c)
  },
  schoolRoll_listSettleAccount: {
    /*
     * 结算方列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/listSettleAccount", p, c)
  },
  schoolRoll_listSimpleByUserId: {
    /*
     * 简易学籍列表
     * userId 用户id (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/listSimpleByUserId", p, c)
  },
  schoolRoll_listSourceFrom: {
    /*
     * 来源详情列表
     */
    get: (p, c) => $.get("/api/ems/education/schoolRoll/listSourceFrom", p, c)
  },
  schoolRoll_passByEducation: {
    /*
     * 教务审核通过
     * headerTeacherId 班主任ID, 继教院审核时必填 (integer query )
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/education/schoolRoll/passByEducation", p, c)
  },
  schoolRoll_passByEnrollTeacher: {
    /*
     * 招生老师通过
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/passByEnrollTeacher", p, c)
  },
  schoolRoll_remarkByEnroll: {
    /*
     * 招生备注
     * id id (integer query required)
     * remark 备注 (string query required)
     */
    put: (p, c) => $.put("/api/ems/education/schoolRoll/remarkByEnroll", p, c)
  },
  schoolRoll_removeAgreement: {
    /*
     * 删除正式报读协议
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/education/schoolRoll/removeAgreement", p, c)
  },
  schoolRoll_removeFrontAgreement: {
    /*
     * 删除报读须知
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/removeFrontAgreement", p, c)
  },
  schoolRoll_saveAdminRemark: {
    /*
     * 添加备注（合同负责人）
     * content 内容 (string query required)
     * id 合同id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/education/schoolRoll/saveAdminRemark", p, c)
  },
  schoolRoll_startSchoolRollByFirstFee: {
    /*
     * 合同开始（初次缴费成功）
     * id 学籍id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/startSchoolRollByFirstFee", p, c)
  },
  schoolRoll_tmpRepairChangeSite: {
    /*
     * 临时修复-宁工程校本部学生转宁工程
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRoll/tmpRepairChangeSite", p, c)
  },
  schoolRoll_transferAdminTeacher: {
    /*
     * 移交合同负责人
     * adminTeacherId 原合同负责人 (integer query required)
     * newAdminTeacherId 新合同负责人 (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/transferAdminTeacher", p, c)
  },
  schoolRoll_troubled_addContent: {
    /*
     * 添加处理
     * content 处理内容 (string query required)
     * extraFile 附件 (string query )
     * id id (integer query required)
     * nextContactAdminId 下次沟通人, 未解决必填 (integer query )
     * nextContactTime 下次沟通时间 (string query )
     * solvedStatus 解决状态 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRoll/troubled/addContent", p, c)
  },
  schoolRoll_troubled_changeNextContactAdmin: {
    /*
     * 更换下一处理人（标记人可以）
     * id 处理记录id (integer query required)
     * nextContactAdminId 下一处理人 (integer query required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/schoolRoll/troubled/changeNextContactAdmin",
        p,
        c
      )
  },
  schoolRoll_troubled_exportForFront: {
    /*
     * 导出-前端
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/troubled/exportForFront", p, c)
  },
  schoolRoll_troubled_exportForService: {
    /*
     * 导出-后端
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/troubled/exportForService", p, c)
  },
  schoolRoll_troubled_finish: {
    /*
     * 标记已解决
     * content 处理结果 (string query required)
     * extraFile 附件 (string query )
     * id id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRoll/troubled/finish", p, c)
  },
  schoolRoll_troubled_listForFront: {
    /*
     * 列表-前端
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/troubled/listForFront", p, c)
  },
  schoolRoll_troubled_listForService: {
    /*
     * 列表-后端
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/troubled/listForService", p, c)
  },
  schoolRoll_troubled_listRecord: {
    /*
     * 处理记录
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/troubled/listRecord", p, c)
  },
  schoolRoll_troubled_save: {
    /*
     * 标记问题学生
     * category 分类(key=问题学生分类) (string query required)
     * extraFile 附件 (string query )
     * nextContactAdminId 下次沟通人 (integer query required)
     * nextContactTime 下次沟通时间 (string query )
     * reason 理由 (string query required)
     * schoolRollId 合同编号 (integer query required)
     */
    post: (p, c) => $.post("/api/ems/education/schoolRoll/troubled/save", p, c)
  },
  schoolRoll_updateByEducation: {
    /*
     * 招办老师编辑
     * addScoreItem 加分项 (string query )
     * address 身份证地址 (string query )
     * adultExamArea 成考考区 (string query )
     * adultExamCity 成考地级市 (string query )
     * approvalFormPhoto 核准单照片 (string query )
     * armyAward 个人军功（免试专升本） (string query )
     * armyAwardFileUrl 军功证书（免试专升本） (string query )
     * armyProof 退役军人凭证 (string query )
     * armyStatus 是否退役军人 (string query )
     * campus 期末考区 (string query )
     * certificatePhoto 特殊证件 (string query )
     * companyAddress 单位地址 (string query )
     * companyName 单位名称 (string query )
     * contactPhone 联系电话 (string query )
     * degreeApply 学位申请 (string query )
     * diplomaNo 毕业证书编号 (string query )
     * diplomaPhoto 毕业证照片 (string query )
     * domicileArea 户籍所在地 (string query )
     * educationLevel 学历层次 (string query )
     * educationNetCertificateNo 备案表在线验证码 (string query )
     * educationNetCertificatePhoto 学历电子注册备案表（专升本必填） (string query )
     * emergencyContactName 紧急联系人 (string query )
     * emergencyContactPhone 紧急联系电话 (string query )
     * enterArmyArea 应征入伍地（免试专升本） (string query )
     * enterArmyTime 入伍时间（免试专升本） (string query )
     * examRegister 考试院注册 (string query )
     * examStudentCategory 考生类别：应届生|非应届生（免试专升本） (string query )
     * experience 是否10天体验期学员-自考 (string query )
     * extraFile 报名表（国开选填，继教院必填，其他隐藏） (string query )
     * graduationMajor 毕业专业 (string query )
     * graduationSchool 毕业院校 (string query )
     * graduationTime 毕业时间 (string query )
     * id 学籍信息id (integer query )
     * idCardBackPhoto 身份证反面 (string query )
     * idCardFrontPhoto 身份证正面 (string query )
     * idCardNo 身份证号 (string query )
     * leaveArmyDomicileArea 退伍安置地（免试专升本） (string query )
     * leaveArmyTime 退伍时间（免试专升本） (string query )
     * loan 是否助学贷款学员-自考 (string query )
     * localType 成考所在地类型 (string query )
     * multifunction 是否一报双考学员-自考 (string query )
     * name 姓名 (string query )
     * nation 民族 (string query )
     * natives 是否省内（继教院隐藏） (string query )
     * notNeedExamItem 免试项 (string query )
     * originSource 学生来源 (string query )
     * otherCredentials 其他证件 (string query )
     * paymentVoucher 缴费凭证（继教院） (string query )
     * photo 个人照 (string query )
     * politicalStatus 政治面貌 (string query )
     * preDegreeStatus 前置学历状态 (string query )
     * preHeaderTeacher 前置学历班主任 (string query )
     * preHeaderTeacherPhone 前置学历班主任联系方式 (string query )
     * registerArea 注册地 (string query )
     * residencePermitFlag 已有居住证（是否） (string query )
     * residencePermitPreRemindTime 居住证提醒时间 (string query )
     * residencePermitUrl 居住证地址 (string query )
     * retiredAcceptAddress 退役安置接受地 (string query )
     * retirementCertificatePhoto 退役证照片 (string query )
     * shippingAddress 收件地址 (string query )
     * socialSecurityPhoto 社保缴纳证明照片 (string query )
     * sourceFrom 来源详情（招生老师角色包含同行招生老师或者招生老师部门包含电销） (string query )
     * userSecondPhoto 个人照2 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/updateByEducation", p, c)
  },
  schoolRoll_updateByEnroll: {
    /*
     * 招生老师编辑
     * addScoreItem 加分项 (string query )
     * address 身份证地址 (string query )
     * adultExamArea 成考考区 (string query )
     * adultExamCity 成考地级市 (string query )
     * approvalFormPhoto 核准单照片 (string query )
     * armyAward 个人军功（免试专升本） (string query )
     * armyAwardFileUrl 军功证书（免试专升本） (string query )
     * armyProof 退役军人凭证 (string query )
     * armyStatus 是否退役军人 (string query )
     * campus 期末考区 (string query )
     * certificatePhoto 特殊证件 (string query )
     * companyAddress 单位地址 (string query )
     * companyName 单位名称 (string query )
     * contactPhone 联系电话 (string query )
     * degreeApply 学位申请 (string query )
     * diplomaNo 毕业证书编号 (string query )
     * diplomaPhoto 毕业证照片 (string query )
     * domicileArea 户籍所在地 (string query )
     * educationLevel 学历层次 (string query )
     * educationNetCertificateNo 备案表在线验证码 (string query )
     * educationNetCertificatePhoto 学历电子注册备案表（专升本必填） (string query )
     * emergencyContactName 紧急联系人 (string query )
     * emergencyContactPhone 紧急联系电话 (string query )
     * enterArmyArea 应征入伍地（免试专升本） (string query )
     * enterArmyTime 入伍时间（免试专升本） (string query )
     * examRegister 考试院注册 (string query )
     * examStudentCategory 考生类别：应届生|非应届生（免试专升本） (string query )
     * experience 是否10天体验期学员-自考 (string query )
     * extraFile 报名表（国开选填，继教院必填，其他隐藏） (string query )
     * graduationMajor 毕业专业 (string query )
     * graduationSchool 毕业院校 (string query )
     * graduationTime 毕业时间 (string query )
     * id 学籍信息id (integer query )
     * idCardBackPhoto 身份证反面 (string query )
     * idCardFrontPhoto 身份证正面 (string query )
     * idCardNo 身份证号 (string query )
     * leaveArmyDomicileArea 退伍安置地（免试专升本） (string query )
     * leaveArmyTime 退伍时间（免试专升本） (string query )
     * loan 是否助学贷款学员-自考 (string query )
     * localType 成考所在地类型 (string query )
     * multifunction 是否一报双考学员-自考 (string query )
     * name 姓名 (string query )
     * nation 民族 (string query )
     * natives 是否省内（继教院隐藏） (string query )
     * notNeedExamItem 免试项 (string query )
     * otherCredentials 其他证件 (string query )
     * paymentVoucher 缴费凭证（继教院） (string query )
     * photo 个人照 (string query )
     * politicalStatus 政治面貌 (string query )
     * preDegreeStatus 前置学历状态 (string query )
     * preHeaderTeacher 前置学历班主任 (string query )
     * preHeaderTeacherPhone 前置学历班主任联系方式 (string query )
     * registerArea 注册地 (string query )
     * residencePermitFlag 已有居住证（是否） (string query )
     * residencePermitPreRemindTime 居住证提醒时间 (string query )
     * residencePermitUrl 居住证地址 (string query )
     * retiredAcceptAddress 退役安置接受地 (string query )
     * retirementCertificatePhoto 退役证照片 (string query )
     * shippingAddress 收件地址 (string query )
     * socialSecurityPhoto 社保缴纳证明照片 (string query )
     * sourceFrom 来源详情（招生老师角色包含同行招生老师或者招生老师部门包含电销） (string query )
     * userSecondPhoto 个人照2 (string query )
     */
    put: (p, c) => $.put("/api/ems/education/schoolRoll/updateByEnroll", p, c)
  },
  schoolRoll_updateByService: {
    /*
     * 服务老师编辑
     * awards 所获奖项 (string query )
     * awardsRemark 奖项备注 (string query )
     * billInfo 结算信息 (string query )
     * campus 考区 (string query )
     * companyAddress  (string query )
     * companyName  (string query )
     * contactPhone 联系电话 (string query )
     * degreeApply 是否申请学位 (string query )
     * diplomaNo 毕业证书编号 (string query )
     * diplomaPhoto 毕业证照片 (string query )
     * driverCertificate 驾驶证培训证书 (string query )
     * driverEndTime 驾驶证培训结束时间 (string query )
     * driverStartTime 驾驶证培训开始时间 (string query )
     * driverStatus 驾驶证培训状态 (string query )
     * educationLevel 学历层次 (string query )
     * emergencyContactName 联系人 (string query )
     * emergencyContactPhone 联系人电话 (string query )
     * employmentStatus 就业状态 (string query )
     * employmentStatusRemark 就业状态备注 (string query )
     * endTime 培训结束时间 (string query )
     * enterpriseExamPoint 企业学生期末考点 (string query )
     * examMonth 考试月份 (integer query )
     * examRegister 考试院注册 (string query )
     * experience 是否10体验期学员 (string query )
     * graduationMajor 毕业专业 (string query )
     * graduationSchool 毕业院校 (string query )
     * graduationTime 毕业时间 (string query )
     * humanStatus 人社证书状态 (string query )
     * id 学籍信息id (integer query )
     * idCardNo 身份证，只传入，不编辑 (string query )
     * industry 就业行业 (string query )
     * industryRemark 行业备注 (string query )
     * localType 成考所在地类型，前端根据规则传入 (string query )
     * onlineEnrollTime 线上报名时间 (string query )
     * photoCollection 毕业照片采集地 (string query )
     * qualifiedCertificate 合格证书 (string query )
     * registerArea 注册地 (string query )
     * repairCertificate 汽修培训证书 (string query )
     * repairEndTime 汽修培训结束时间 (string query )
     * repairStartTime 汽修培训开始时间 (string query )
     * repairStatus 汽修培训状态 (string query )
     * residencePermitFlag 已有居住证（是否） (string query )
     * residencePermitUrl 居住证地址 (string query )
     * schoolAccount 学习平台账号 (string query )
     * schoolPassword 学习平台Miami (string query )
     * shippingAddress 收件地址 (string query )
     * socialSecurityPhoto 社保缴纳证明照片 (string query )
     * socialSecurityStatus 是否缴纳社保:是否 (string query )
     * startTime 培训开始时间 (string query )
     * subsidyAmount 生活补贴发放金额 (number query )
     * subsidyPayTime 生活补贴发放时间 (string query )
     * trainingRemark 培训备注 (string query )
     * trainingStatus 培训状态 (string query )
     * tutorStatus 辅导情况 (string query )
     * unit 就业单位 (string query )
     * unitNature 单位性质 (string query )
     * unitNatureRemark 单位性质备注 (string query )
     * wenhuiOpen 文辉教育学习平台是否开通 (string query )
     * workingCertificatePhoto 工作证明 (string query )
     * workingCertificatePhotoType 工作证明等照片的具体类型说明 (string query )
     */
    put: (p, c) => $.put("/api/ems/education/schoolRoll/updateByService", p, c)
  },
  schoolRoll_updateForSuspend: {
    /*
     * 编辑单个休学学生
     * id 学籍id (integer query required)
     * suspendEnd 休学结束时间 (string query required)
     */
    put: (p, c) => $.put("/api/ems/education/schoolRoll/updateForSuspend", p, c)
  },
  schoolRoll_uploadAgreement: {
    /*
     * 上传正式报读协议
     * agreementUrl 报读须知地址 (string query required)
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/education/schoolRoll/uploadAgreement", p, c)
  },
  schoolRoll_uploadAgreementForClient: {
    /*
     * C端上传正式报读协议（学生签名）
     * id id (integer query required)
     * signData 签名图片，png文件，base64值 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/uploadAgreementForClient", p, c)
  },
  schoolRoll_uploadBeijingConfirmForClient: {
    /*
     * C端上传北开确认书（学生签名）
     * id id (integer query required)
     * signData 签名图片，png文件，base64值 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/uploadBeijingConfirmForClient", p, c)
  },
  schoolRoll_uploadFrontAgreement: {
    /*
     * 上传录取前报读须知
     * agreementUrl 报读地址 (string query required)
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/uploadFrontAgreement", p, c)
  },
  schoolRoll_uploadFrontAgreementForClient: {
    /*
     * C端上传录取前报读须知（学生签名）
     * id id (integer query required)
     * signData 签名图片，png文件，base64值 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/uploadFrontAgreementForClient", p, c)
  },
  schoolRoll_uploadSchoolingForExemptionDegree: {
    /*
     * 批量导入录取名单(免试专升本)
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/schoolRoll/uploadSchoolingForExemptionDegree",
        p,
        c
      )
  },

  /**
   * 学历合同信息
   */
  schoolRollAdult_admission: {
    /*
     * 录取
     * contractId 所属站点id (integer query required)
     * id 合同id (integer query required)
     * studentExamNo 考生号 (string query )
     * studentNo 学号 (string query )
     */
    put: (p, c) => $.put("/api/ems/education/schoolRollAdult/admission", p, c)
  },
  schoolRollAdult_detailsForEducation: {
    /*
     * 教务学生详情
     * id 学籍id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/detailsForEducation", p, c)
  },
  schoolRollAdult_detailsForFront: {
    /*
     * 前端学籍合同详情（报名确认、招生统计、招办审核、招办学生）--成教远程国开
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/detailsForFront", p, c)
  },
  schoolRollAdult_detailsForFrontForClient: {
    /*
     * 前端学籍合同详情-C端学生查看编辑
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/detailsForFrontForClient", p, c)
  },
  schoolRollAdult_detailsForService: {
    /*
     * 学籍合同详情
     * id id (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/detailsForService", p, c)
  },
  schoolRollAdult_downloadAdmissionMould: {
    /*
     * 下载录取名单模版
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/downloadAdmissionMould", p, c)
  },
  schoolRollAdult_downloadEducationMould: {
    /*
     * 下载教务学生模版
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/downloadEducationMould", p, c)
  },
  schoolRollAdult_downloadMouldForCampusOrEnterprisePoint: {
    /*
     * 期末考区或校企学生期末考点导入模板
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollAdult/downloadMouldForCampusOrEnterprisePoint",
        p,
        c
      )
  },
  schoolRollAdult_downloadPassedStudentInfo: {
    /*
     * 已通过学生的资料下载
     * ids id (array query )
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollAdult/downloadPassedStudentInfo",
        p,
        c
      )
  },
  schoolRollAdult_downloadSpecialStudentMould: {
    /*
     * 下载导入特殊学生模版
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollAdult/downloadSpecialStudentMould",
        p,
        c
      )
  },
  schoolRollAdult_exportForEducation: {
    /*
     * 教务学生列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/exportForEducation", p, c)
  },
  schoolRollAdult_exportForEducationConfirm: {
    /*
     * 招办审核列表导出
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollAdult/exportForEducationConfirm",
        p,
        c
      )
  },
  schoolRollAdult_exportForEducationWarning: {
    /*
     * 学籍预警学生列表导出(教务)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollAdult/exportForEducationWarning",
        p,
        c
      )
  },
  schoolRollAdult_exportForEnroll: {
    /*
     * 招办学生列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/exportForEnroll", p, c)
  },
  schoolRollAdult_exportForServiceWarning: {
    /*
     * 学籍预警学生列表导出(服务)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/exportForServiceWarning", p, c)
  },
  schoolRollAdult_exportStudent: {
    /*
     * 服务学生列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/exportStudent", p, c)
  },
  schoolRollAdult_getAdmissionLetterForClient: {
    /*
     * C端查询录取通知书-园丁
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollAdult/getAdmissionLetterForClient",
        p,
        c
      )
  },
  schoolRollAdult_listForEducation: {
    /*
     * 教务学生列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/listForEducation", p, c)
  },
  schoolRollAdult_listForEducationConfirm: {
    /*
     * 招办审核列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/listForEducationConfirm", p, c)
  },
  schoolRollAdult_listForEducationWarning: {
    /*
     * 学籍预警学生列表(教务)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/listForEducationWarning", p, c)
  },
  schoolRollAdult_listForEnroll: {
    /*
     * 招办学生列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/listForEnroll", p, c)
  },
  schoolRollAdult_listForServiceWarning: {
    /*
     * 学籍预警学生列表(服务)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/listForServiceWarning", p, c)
  },
  schoolRollAdult_listStudent: {
    /*
     * 服务学生列表
     */
    get: (p, c) => $.get("/api/ems/education/schoolRollAdult/listStudent", p, c)
  },
  schoolRollAdult_listUnAssign: {
    /*
     * 未分配学生列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/listUnAssign", p, c)
  },
  schoolRollAdult_updateByClient: {
    /*
     * C端学生查看编辑, 招生老师审核中的方可编辑
     * address 身份证地址 (string query )
     * auditStep 审核情况 (string query )
     * batch 批次 (string query )
     * birth 出生日期 (string query )
     * certificatePhoto 特殊证件(药学护理证件|人社证书的特殊证件) (string query )
     * contactPhone 联系电话 (string query )
     * denyReason 拒绝原因 (string query )
     * diplomaNo 毕业证书编号 (string query )
     * diplomaPhoto 毕业证 (string query )
     * discipline 科类 (string query )
     * eduAuditTime 招办审核时间 (string query )
     * educationLevel 毕业学历层次 (string query )
     * educationNetCertificateInfo 学信网零散查询 (string query )
     * educationNetCertificatePhoto 学历电子注册备案表（专升本必填） (string query )
     * emergencyContactName 紧急联系人 (string query )
     * emergencyContactPhone 紧急联系电话 (string query )
     * enrollLevel 层次 (string query )
     * gender 性别 (string query )
     * graduationMajor 毕业专业 (string query )
     * graduationSchool 毕业院校 (string query )
     * graduationTime 毕业时间 (string query )
     * id 学籍信息id (integer query )
     * idCardBackPhoto 身份证反面 (string query )
     * idCardFrontPhoto 身份证正面 (string query )
     * idCardNo 身份证号 (string query )
     * major 专业 (string query )
     * name 姓名 (string query )
     * nation 民族 (string query )
     * phone 注册手机号 (string query )
     * photo 个人照 (string query )
     * politicalStatus 政治面貌 (string query )
     * residencePermitFlag 已有居住证（是否） (string query )
     * residencePermitUrl 居住证地址 (string query )
     * shippingAddress 收件地址 (string query )
     * site 学校 (string query )
     * workingCertificatePhoto 工作证明对应的凭证） (string query )
     * workingCertificatePhotoType 工作证明|市民卡|社保卡照片的具体类型说明 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollAdult/updateByClient", p, c)
  },
  schoolRollAdult_updateByEnroll: {
    /*
     * 招生老师编辑
     * addScoreItem 加分项 (string query )
     * address 身份证地址 (string query )
     * adminTeacher 合同负责人 (string query )
     * adminTeacherDepartment 合同负责人部门 (string query )
     * adminTeacherId 合同负责人id (integer query )
     * admissionLetterUrl 录取通知书地址 (string query )
     * adultExamArea 成考考区 (string query )
     * adultExamCity 成考地级市 (string query )
     * adultExamStep 成考阶段 (string query )
     * adultExamYear 成考年度（不可编辑） (string query )
     * agreement 协议号 (string query )
     * agreementTime 报读协议签署时间 (string query )
     * agreementUrl 报读协议 (string query )
     * armyProof 退役军人凭证 (string query )
     * armyStatus 是否退役军人 (string query )
     * auditStep 审核情况 (string query )
     * batch 批次 (string query )
     * birth 出生日期 (string query )
     * campus 期末考区 (string query )
     * certificatePhoto 特殊证件(药学护理证件|人社证书的特殊证件) (string query )
     * ckbdDeadLine 成考宝典试用截至时间 (string query )
     * clueCirculateApplyId 线索流转人id (integer query )
     * clueCirculateApplyName 线索流转人 (string query )
     * clueCreator 线索流转人 (string query )
     * clueCreatorId 线索流转人id (integer query )
     * clueId 线索 (integer query )
     * clueOriginChannel 线索来源渠道 (string query )
     * clueOriginDetail 线索具体来源 (string query )
     * companyAddress 单位地址 (string query )
     * companyName 单位名称 (string query )
     * contactPhone 联系电话 (string query )
     * contractCancelTime 退费时间 (string query )
     * contractFinishTime 成交时间 (string query )
     * contractFinishType 合同成交类型 (string query )
     * degreeStatus 学位状态(只招办可编辑) (string query )
     * denyReason 拒绝原因 (string query )
     * department 合同部门 (string query )
     * departmentId 合同部门id (integer query )
     * diplomaNo 毕业证书编号 (string query )
     * diplomaPhoto 毕业证 (string query )
     * discipline 科类 (string query )
     * discountAmount 优惠金额 (number query )
     * discountType 优惠类型 (string query )
     * domicileArea 户籍所在地 (string query )
     * eduAuditName 招办老师(如果审核人为空则取学校招办老师字段) (string query )
     * eduAuditTime 招办审核时间 (string query )
     * educationLevel 学历层次 (string query )
     * educationNetCertificateInfo 学信网零散查询 (string query )
     * educationNetCertificateNo 备案表在线验证码 (string query )
     * educationNetCertificatePhoto 学历电子注册备案表（专升本必填） (string query )
     * emergencyContactName 紧急联系人 (string query )
     * emergencyContactPhone 紧急联系电话 (string query )
     * enrollLevel 层次 (string query )
     * enrollRemark 招生老师备注 (string query )
     * enrollTeacher 招生老师 (string query )
     * enrollTeacherDepartment 招生老师部门 (string query )
     * enrollTeacherId 招生老师id (integer query )
     * enrollTeacherPosition 招生老师角色 (string query )
     * enrollTime 报名时间 (string query )
     * enterprise 校企学生单位（不可编辑，通过企业扫码报名的学生特有） (string query )
     * frontAgreementUrl 报读须知 (string query )
     * gender 性别 (string query )
     * graduationDiscipline 毕业科类 (string query )
     * graduationMajor 毕业专业 (string query )
     * graduationSchool 毕业院校 (string query )
     * graduationTime 毕业时间 (string query )
     * headerTeacher 班主任 (string query )
     * headerTeacherId 班主任id (integer query )
     * id 学籍信息id (integer query )
     * idCardBackPhoto 身份证反面 (string query )
     * idCardFrontPhoto 身份证正面 (string query )
     * idCardNo 身份证号 (string query )
     * liveStatus 流失状态 (string query )
     * localType 成考所在地类型 (string query )
     * loseRiskLevel 流失风险等级 (string query )
     * major 专业 (string query )
     * majorId 专业id (integer query )
     * name 姓名 (string query )
     * nation 民族 (string query )
     * natives 是否省内（继教院隐藏） (string query )
     * notNeedExamItem 免试项 (string query )
     * oldSchoolRollId 老合同编号 (integer query )
     * originSource 学生来源（教务审核显示） (string query )
     * performanceTime 业绩核算时间 (string query )
     * phone 注册手机号 (string query )
     * photo 个人照 (string query )
     * politicalStatus 政治面貌 (string query )
     * preDegreeStatus 前置学历状态 (string query )
     * preHeaderTeacher 前置学历班主任 (string query )
     * preHeaderTeacherPhone 前置学历班主任联系方式 (string query )
     * referralUserId 推荐人id (integer query )
     * referralUserName 推荐人名字 (string query )
     * referralUserPhone 推荐人手机号 (string query )
     * residencePermitFlag 已有居住证（是否） (string query )
     * residencePermitPreRemindTime 居住证提醒时间 (string query )
     * residencePermitUrl 居住证地址 (string query )
     * schoolStatus 学籍状态 (string query )
     * shippingAddress 收件地址 (string query )
     * site 学校 (string query )
     * siteId 学校id (integer query )
     * siteProvince 学校省份 (string query )
     * siteType 学校类型 (string query )
     * sourceFrom 来源详情（招生老师角色包含同行招生老师或者招生老师部门包含电销） (string query )
     * sourceFromDetail 具体来源详情 (string query )
     * specialFlag 是否特殊学生(只招办可编辑) (string query )
     * specialRemark 特殊学生备注(只招办可编辑) (string query )
     * tuitionStatus 缴费状态 (string query )
     * userId 用户id (integer query )
     * userSecondPhoto 个人照2 (string query )
     * workingCertificatePhoto 工作证明对应的凭证） (string query )
     * workingCertificatePhotoType 工作证明|市民卡|社保卡照片的具体类型说明 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollAdult/updateByEnroll", p, c)
  },
  schoolRollAdult_updateByEnrollEducation: {
    /*
     * 招办老师编辑
     * addScoreItem 加分项 (string query )
     * address 身份证地址 (string query )
     * adminTeacher 合同负责人 (string query )
     * adminTeacherDepartment 合同负责人部门 (string query )
     * adminTeacherId 合同负责人id (integer query )
     * admissionLetterUrl 录取通知书地址 (string query )
     * adultExamArea 成考考区 (string query )
     * adultExamCity 成考地级市 (string query )
     * adultExamStep 成考阶段 (string query )
     * adultExamYear 成考年度（不可编辑） (string query )
     * agreement 协议号 (string query )
     * agreementTime 报读协议签署时间 (string query )
     * agreementUrl 报读协议 (string query )
     * armyProof 退役军人凭证 (string query )
     * armyStatus 是否退役军人 (string query )
     * auditStep 审核情况 (string query )
     * batch 批次 (string query )
     * birth 出生日期 (string query )
     * campus 期末考区 (string query )
     * certificatePhoto 特殊证件(药学护理证件|人社证书的特殊证件) (string query )
     * ckbdDeadLine 成考宝典试用截至时间 (string query )
     * clueCirculateApplyId 线索流转人id (integer query )
     * clueCirculateApplyName 线索流转人 (string query )
     * clueCreator 线索流转人 (string query )
     * clueCreatorId 线索流转人id (integer query )
     * clueId 线索 (integer query )
     * clueOriginChannel 线索来源渠道 (string query )
     * clueOriginDetail 线索具体来源 (string query )
     * companyAddress 单位地址 (string query )
     * companyName 单位名称 (string query )
     * contactPhone 联系电话 (string query )
     * contractCancelTime 退费时间 (string query )
     * contractFinishTime 成交时间 (string query )
     * contractFinishType 合同成交类型 (string query )
     * degreeStatus 学位状态(只招办可编辑) (string query )
     * denyReason 拒绝原因 (string query )
     * department 合同部门 (string query )
     * departmentId 合同部门id (integer query )
     * diplomaNo 毕业证书编号 (string query )
     * diplomaPhoto 毕业证 (string query )
     * discipline 科类 (string query )
     * discountAmount 优惠金额 (number query )
     * discountType 优惠类型 (string query )
     * domicileArea 户籍所在地 (string query )
     * eduAuditName 招办老师(如果审核人为空则取学校招办老师字段) (string query )
     * eduAuditTime 招办审核时间 (string query )
     * educationLevel 学历层次 (string query )
     * educationNetCertificateInfo 学信网零散查询 (string query )
     * educationNetCertificateNo 备案表在线验证码 (string query )
     * educationNetCertificatePhoto 学历电子注册备案表（专升本必填） (string query )
     * emergencyContactName 紧急联系人 (string query )
     * emergencyContactPhone 紧急联系电话 (string query )
     * enrollLevel 层次 (string query )
     * enrollRemark 招生老师备注 (string query )
     * enrollTeacher 招生老师 (string query )
     * enrollTeacherDepartment 招生老师部门 (string query )
     * enrollTeacherId 招生老师id (integer query )
     * enrollTeacherPosition 招生老师角色 (string query )
     * enrollTime 报名时间 (string query )
     * enterprise 校企学生单位（不可编辑，通过企业扫码报名的学生特有） (string query )
     * frontAgreementUrl 报读须知 (string query )
     * gender 性别 (string query )
     * graduationDiscipline 毕业科类 (string query )
     * graduationMajor 毕业专业 (string query )
     * graduationSchool 毕业院校 (string query )
     * graduationTime 毕业时间 (string query )
     * headerTeacher 班主任 (string query )
     * headerTeacherId 班主任id (integer query )
     * id 学籍信息id (integer query )
     * idCardBackPhoto 身份证反面 (string query )
     * idCardFrontPhoto 身份证正面 (string query )
     * idCardNo 身份证号 (string query )
     * liveStatus 流失状态 (string query )
     * localType 成考所在地类型 (string query )
     * loseRiskLevel 流失风险等级 (string query )
     * major 专业 (string query )
     * majorId 专业id (integer query )
     * name 姓名 (string query )
     * nation 民族 (string query )
     * natives 是否省内（继教院隐藏） (string query )
     * notNeedExamItem 免试项 (string query )
     * oldSchoolRollId 老合同编号 (integer query )
     * originSource 学生来源（教务审核显示） (string query )
     * performanceTime 业绩核算时间 (string query )
     * phone 注册手机号 (string query )
     * photo 个人照 (string query )
     * politicalStatus 政治面貌 (string query )
     * preDegreeStatus 前置学历状态 (string query )
     * preHeaderTeacher 前置学历班主任 (string query )
     * preHeaderTeacherPhone 前置学历班主任联系方式 (string query )
     * referralUserId 推荐人id (integer query )
     * referralUserName 推荐人名字 (string query )
     * referralUserPhone 推荐人手机号 (string query )
     * residencePermitFlag 已有居住证（是否） (string query )
     * residencePermitPreRemindTime 居住证提醒时间 (string query )
     * residencePermitUrl 居住证地址 (string query )
     * schoolStatus 学籍状态 (string query )
     * shippingAddress 收件地址 (string query )
     * site 学校 (string query )
     * siteId 学校id (integer query )
     * siteProvince 学校省份 (string query )
     * siteType 学校类型 (string query )
     * sourceFrom 来源详情（招生老师角色包含同行招生老师或者招生老师部门包含电销） (string query )
     * sourceFromDetail 具体来源详情 (string query )
     * specialFlag 是否特殊学生(只招办可编辑) (string query )
     * specialRemark 特殊学生备注(只招办可编辑) (string query )
     * tuitionStatus 缴费状态 (string query )
     * userId 用户id (integer query )
     * userSecondPhoto 个人照2 (string query )
     * workingCertificatePhoto 工作证明对应的凭证） (string query )
     * workingCertificatePhotoType 工作证明|市民卡|社保卡照片的具体类型说明 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollAdult/updateByEnrollEducation", p, c)
  },
  schoolRollAdult_updateByService: {
    /*
     * 服务学生编辑
     * addScoreItem 加分项 (string query )
     * address 身份证地址 (string query )
     * adminTeacher 合同负责人 (string query )
     * adminTeacherDepartment 合同负责人部门 (string query )
     * admissionLetterUrl 录取通知书地址 (string query )
     * adultExamArea 成考考区 (string query )
     * adultExamCity 成考地级市 (string query )
     * adultExamStep 成考阶段 (string query )
     * adultExamYear 成考年度 (string query )
     * agreement 协议号 (string query )
     * agreementUrl 报读协议 (string query )
     * armyProof 退役军人凭证 (string query )
     * armyStatus 是否退役军人 (string query )
     * auditStep 审核情况 (string query )
     * batch 批次 (string query )
     * birth 出生日期 (string query )
     * campus 期末考区 (string query )
     * certificatePhoto 特殊证件(药学或护理执业证书) (string query )
     * clueId 线索 (integer query )
     * companyAddress 单位地址 (string query )
     * companyName 单位名称 (string query )
     * contactPhone 联系电话 (string query )
     * contractCancelTime 退费时间 (string query )
     * contractFinishTime 成交时间 (string query )
     * courseAvgScore 总成绩平均分 (number query )
     * createTime 报名时间 (string query )
     * degreeApply 学位申请情况 (string query )
     * degreeCourseAvgScore 学位课平均分 (number query )
     * degreeStatus 学位状态 (string query )
     * denyReason 拒绝原因 (string query )
     * department 合同部门 (string query )
     * departmentId 合同部门ID (integer query )
     * diplomaNo 毕业证书编号 (string query )
     * diplomaPhoto 毕业证照片 (string query )
     * discipline 科类 (string query )
     * discountAmount 优惠金额 (number query )
     * discountType 优惠类型 (string query )
     * domicileArea 户籍所在地 (string query )
     * eduAuditName 招办老师(如果审核人为空则取学校招办老师字段) (string query )
     * eduAuditTime 招办审核时间 (string query )
     * eduRemark 教务备注 (string query )
     * educationLevel 学历层次 (string query )
     * educationNetCertificateNo 备案表在线验证码 (string query )
     * educationNetCertificatePhoto 学历电子注册备案表（专升本必填） (string query )
     * emergencyContactName 紧急联系人 (string query )
     * emergencyContactPhone 紧急联系电话 (string query )
     * enrollLevel 层次 (string query )
     * enrollRemark 招生老师备注 (string query )
     * enrollTeacher 招生老师 (string query )
     * enrollTeacherDepartment 招生老师部门 (string query )
     * enrollTeacherId 招生老师id (integer query )
     * enrollTeacherPosition 招生老师角色 (string query )
     * enterprise 校企学生单位（不可编辑，通过企业扫码报名的学生特有） (string query )
     * enterpriseExamPoint 企业学生期末考点 (string query )
     * extraFile 报名表（国开选填，继教院必填，其他隐藏） (string query )
     * followStatus  (string query )
     * frontAgreementUrl 报读须知 (string query )
     * gender 性别 (string query )
     * graduationDiscipline 毕业科类 (string query )
     * graduationMajor 毕业专业 (string query )
     * graduationSchool 毕业院校 (string query )
     * graduationTime 毕业时间 (string query )
     * headerTeacher 班主任 (string query )
     * headerTeacherId 班主任id (integer query )
     * id 学籍信息id (integer query )
     * idCardBackPhoto 身份证反面 (string query )
     * idCardFrontPhoto 身份证正面 (string query )
     * idCardNo 身份证号 (string query )
     * liveStatus 流失状态 (string query )
     * localType 成考所在地类型 (string query )
     * loseRiskLevel 流失风险等级 (string query )
     * major 专业 (string query )
     * majorId 专业id (integer query )
     * name 姓名 (string query )
     * nation 民族 (string query )
     * natives 是否省内（继教院隐藏） (string query )
     * notNeedExamItem 免试项 (string query )
     * oldSchoolRollId 老合同编号 (integer query )
     * originSource 学生来源（教务审核显示） (string query )
     * performanceTime 业绩核算时间 (string query )
     * phone 注册手机号 (string query )
     * photo 个人照 (string query )
     * photoCollection 毕业照片采集地 (string query )
     * platformUrl 学习平台地址 (string query )
     * referralUserId 推荐人id (integer query )
     * referralUserName 推荐人名字 (string query )
     * referralUserPhone 推荐人手机号 (string query )
     * residencePermitFlag 已有居住证（是否） (string query )
     * residencePermitPreRemindTime 居住证提醒时间 (string query )
     * residencePermitUrl 居住证地址 (string query )
     * rollGrade 学籍年级 (string query )
     * schoolAccount 平台账号 (string query )
     * schoolPassword 平台密码 (string query )
     * schoolStatus 学籍状态 (string query )
     * serviceRemark 服务备注 (string query )
     * shippingAddress 收件地址 (string query )
     * site 学校 (string query )
     * siteId 学校id (integer query )
     * siteProvince 学校省份 (string query )
     * siteType 学校类型 (string query )
     * sorting 总成绩平均分专业排名 (integer query )
     * sourceFrom 来源详情（招生老师角色包含同行招生老师或者招生老师部门包含电销） (string query )
     * specialFlag 是否特殊学生 (string query )
     * specialRemark 特殊学生备注 (string query )
     * studentExamNo 考生号 (string query )
     * studentNo 学号 (string query )
     * thesisStep 论文阶段 (string query )
     * tuitionStatus 缴费状态 (string query )
     * userId 用户id (integer query )
     * userSecondPhoto 个人照2 (string query )
     * workingCertificatePhoto 工作证明 (string query )
     * workingCertificatePhotoType 工作证明等照片的具体类型说明 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollAdult/updateByService", p, c)
  },
  schoolRollAdult_updateEducation: {
    /*
     * 编辑教务学生
     * eduRemark 教务备注 (string query )
     * id 学籍id (integer query required)
     * idCardBackPhoto 身份证背面 (string query )
     * idCardFrontPhoto 身份证正面 (string query )
     * idCardNo 身份证 (string query )
     * name 姓名 (string query )
     * nation 民族 (string query )
     * realGraduateTime 毕业时间 (string query )
     * rollGrade 学籍年级 (string query )
     * studentExamNo 考生号 (string query )
     * studentNo 学号 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollAdult/updateEducation", p, c)
  },
  schoolRollAdult_updateEducationWarning: {
    /*
     * 更新学籍到期和预警时间
     * siteType 学校类型 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollAdult/updateEducationWarning", p, c)
  },
  schoolRollAdult_uploadAdmission: {
    /*
     * 导入录取名单
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollAdult/uploadAdmission", p, c)
  },
  schoolRollAdult_uploadAdmissionLetter: {
    /*
     * 导入录取通知书
     * batch 批次 (string query required)
     * idCardNo 身份证号 (string query required)
     * url 地址 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollAdult/uploadAdmissionLetter", p, c)
  },
  schoolRollAdult_uploadCampusOrEnterprisePoint: {
    /*
     * 导入更新期末考区或校企学生期末考点
     * clearFlag 导入考区时是否清空企业学生期末考点 (string query )
     * excelFile excelFile (file formData required)
     * type 导入类型:期末考区|企业学生期末考点 (string query required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/schoolRollAdult/uploadCampusOrEnterprisePoint",
        p,
        c
      )
  },
  schoolRollAdult_uploadEducation: {
    /*
     * 导入教务学生
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollAdult/uploadEducation", p, c)
  },
  schoolRollAdult_uploadPhotoCollection: {
    /*
     * 导入毕业照片采集地
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollAdult/uploadPhotoCollection", p, c)
  },
  schoolRollAdult_uploadSpecialStudent: {
    /*
     * 批量导入特殊学生
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollAdult/uploadSpecialStudent", p, c)
  },

  /**
   * 待异动库
   */
  schoolRollBatchTransaction_addSchoolRoll: {
    /*
     * 添加异动合同
     * id ID (integer query )
     * schoolRollId 合同编号 (integer query )
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/schoolRollBatchTransaction/addSchoolRoll",
        p,
        c
      )
  },
  schoolRollBatchTransaction_downloadMould: {
    /*
     * 下载模板
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollBatchTransaction/downloadMould", p, c)
  },
  schoolRollBatchTransaction_export: {
    /*
     * 导出
     * adminTeacherId 合同负责人 (integer query )
     * batch 批次 (string query )
     * finishStatus 是否已异动， 是否 (string query )
     * id ID (integer query required)
     * name 学生姓名 (string query )
     * schoolRollId 合同编号 (integer query )
     * siteId 学校ID (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollBatchTransaction/export", p, c)
  },
  schoolRollBatchTransaction_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollBatchTransaction/list", p, c)
  },
  schoolRollBatchTransaction_listForAdminTeacher: {
    /*
     * 招生管理-待异动库-列表
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollBatchTransaction/listForAdminTeacher",
        p,
        c
      )
  },
  schoolRollBatchTransaction_listRecord: {
    /*
     * 详情
     * adminTeacherId 合同负责人 (integer query )
     * batch 批次 (string query )
     * finishStatus 是否已异动， 是否 (string query )
     * id ID (integer query required)
     * name 学生姓名 (string query )
     * schoolRollId 合同编号 (integer query )
     * siteId 学校ID (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollBatchTransaction/listRecord", p, c)
  },
  schoolRollBatchTransaction_remove: {
    /*
     * 删除
     * id ID (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/education/schoolRollBatchTransaction/remove", p, c)
  },
  schoolRollBatchTransaction_removeSchoolRoll: {
    /*
     * 删除异动合同
     * id ID (integer query required)
     */
    delete: (p, c) =>
      $.delete(
        "/api/ems/education/schoolRollBatchTransaction/removeSchoolRoll",
        p,
        c
      )
  },
  schoolRollBatchTransaction_save: {
    /*
     * 添加编辑
     * deadline 截止时间 (string query required)
     * id ID (integer query )
     * name 名称 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollBatchTransaction/save", p, c)
  },
  schoolRollBatchTransaction_upload: {
    /*
     * 批量导入异动合同
     * excelFile excelFile (file formData required)
     * id 行ID (integer query )
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollBatchTransaction/upload", p, c)
  },

  /**
   * 前置学历待查
   */
  schoolRollChecking_eduAudit: {
    /*
     * 教务审核
     * id ID (integer query required)
     * refuseReason 拒绝理由 (string query )
     * type 类型 1通过 2拒绝 (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollChecking/eduAudit", p, c)
  },
  schoolRollChecking_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/education/schoolRollChecking/list", p, c)
  },
  schoolRollChecking_refresh: {
    /*
     * 刷新数据
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollChecking/refresh", p, c)
  },
  schoolRollChecking_saveFileUrl: {
    /*
     * 保存审核资料
     * extraFileUrl 资料压缩文件地址 (string query required)
     * id ID (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollChecking/saveFileUrl", p, c)
  },
  schoolRollChecking_saveReason: {
    /*
     * 保存待查原因
     * id ID (integer query required)
     * reason 待查原因(下拉 + 其他手填) (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollChecking/saveReason", p, c)
  },
  schoolRollChecking_schoolAudit: {
    /*
     * 高校审核
     * id ID (integer query required)
     * refuseReason 拒绝理由 (string query )
     * type 类型 1通过 2拒绝 (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollChecking/schoolAudit", p, c)
  },

  /**
   * 继教院合同信息
   */
  schoolRollContinue_addForCont: {
    /*
     * 新增(职教学校平台)
     * classRoomId 班级id (integer query required)
     * idCardNo 身份证 (string query required)
     * name 姓名 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollContinue/addForCont", p, c)
  },
  schoolRollContinue_assignClassRoom: {
    /*
     * 分班
     * classRoomId 班级id (integer query required)
     * schoolRollIds 合同id (array query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollContinue/assignClassRoom", p, c)
  },
  schoolRollContinue_assignDormitory: {
    /*
     * 分配寝室
     * bedroomId 宿舍id (integer query required)
     * schoolRollIds 合同id (array query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollContinue/assignDormitory", p, c)
  },
  schoolRollContinue_auditAcceptService: {
    /*
     * 后端服务接收学生-审核
     * headerTeacherId 班主任， 通过必填 (integer query )
     * id id (integer query required)
     * refuseRemark 拒绝理由， 拒绝必填 (string query )
     * status 状态：通过|拒绝 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollContinue/auditAcceptService", p, c)
  },
  schoolRollContinue_clearDormitory: {
    /*
     * 清空寝室
     * schoolRollIds 合同id (array query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollContinue/clearDormitory", p, c)
  },
  schoolRollContinue_clearNotEnrollByAdult: {
    /*
     * 清空本年不报成教数据,定时任务每年1月1日执行
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollContinue/clearNotEnrollByAdult", p, c)
  },
  schoolRollContinue_countUnfinishParentContact: {
    /*
     * 获取未完成联系家长次数（两次）数量
     * headerTeacherId 班主任id (integer query )
     * siteIds 学校id (array query )
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollContinue/countUnfinishParentContact",
        p,
        c
      )
  },
  schoolRollContinue_detailsForFront: {
    /*
     * 前端详情（报名确认、招生统计、招办审核）
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/detailsForFront", p, c)
  },
  schoolRollContinue_detailsForService: {
    /*
     * 后端详情
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/detailsForService", p, c)
  },
  schoolRollContinue_downloadGraduateModule: {
    /*
     * 继教院-下载批量导入毕业名单模版
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollContinue/downloadGraduateModule",
        p,
        c
      )
  },
  schoolRollContinue_downloadSchoolingModule: {
    /*
     * 继教院-下载批量导入在读名单模版
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollContinue/downloadSchoolingModule",
        p,
        c
      )
  },
  schoolRollContinue_downloadSomeInfoForContinueMould: {
    /*
     * 继教院-下载继教院批次修改信息模板
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollContinue/downloadSomeInfoForContinueMould",
        p,
        c
      )
  },
  schoolRollContinue_editForFront: {
    /*
     * 前端编辑（报名确认、招生统计、招办审核）
     * address 身份证地址 (string query )
     * adminTeacher 合同负责人 (string query )
     * adminTeacherDepartment 合同负责人部门 (string query )
     * adminTeacherId 合同负责人id (integer query )
     * agreement 协议号 (string query )
     * agreementTime 报读协议签署时间 (string query )
     * agreementUrl 报读协议 (string query )
     * auditStep 审核情况 (string query )
     * batch 批次 (string query )
     * birth 出生日期 (string query )
     * certificatePhoto 特殊证件(药学护理证件|人社证书的特殊证件) (string query )
     * clueCirculateApplyId 线索流转人id (integer query )
     * clueCirculateApplyName 线索流转人 (string query )
     * clueCreator 线索流转人 (string query )
     * clueCreatorId 线索流转人id (integer query )
     * clueId 线索 (integer query )
     * clueOriginChannel 线索来源渠道 (string query )
     * clueOriginDetail 线索具体来源 (string query )
     * companyAddress 单位地址 (string query )
     * companyName 单位名称 (string query )
     * contactPhone 联系电话 (string query )
     * continueNoticeConfirmTime 告知书签署时间(继教院） (string query )
     * continueNoticeConfirmUrl 告知书地址(继教院） (string query )
     * contractCancelTime 退费时间 (string query )
     * contractFinishTime 成交时间 (string query )
     * contractFinishType 合同成交类型 (string query )
     * denyReason 拒绝原因 (string query )
     * department 合同部门 (string query )
     * departmentId 合同部门id (integer query )
     * diagnosisInfo 诊断情况概述 (string query )
     * diagnosisProof 诊断证明 (string query )
     * diagnosisStatus 是否有诊断证明 (string query )
     * diplomaNo 毕业证书编号 (string query )
     * diplomaPhoto 毕业证 (string query )
     * discipline 科类 (string query )
     * discountAmount 优惠金额 (number query )
     * discountType 优惠类型 (string query )
     * eduAuditName 招办老师(如果审核人为空则取学校招办老师字段) (string query )
     * eduAuditTime 招办审核时间 (string query )
     * educationLevel 学历层次 (string query )
     * educationNetCertificatePhoto 学历电子注册备案表（专升本必填） (string query )
     * emergencyContactName 紧急联系人 (string query )
     * emergencyContactPhone 紧急联系电话 (string query )
     * enrollByOtherStation 学历是否已报他处(继教院) (string query )
     * enrollByOtherStationUrl 学历是否已报他处凭证 (string query )
     * enrollLevel 层次 (string query )
     * enrollReason 报名原因 (string query )
     * enrollRemark 招生老师备注 (string query )
     * enrollTeacher 招生老师 (string query )
     * enrollTeacherDepartment 招生老师部门 (string query )
     * enrollTeacherId 招生老师id (integer query )
     * enrollTeacherPosition 招生老师角色 (string query )
     * enrollTime 报名时间 (string query )
     * enterSchoolDate 报到时间 (string query )
     * extraFile 报名表 (string query )
     * focusInfo 基本情况概述 (string query )
     * focusStatus 是否重点关注 (string query )
     * focusType 重点关注类型 (string query )
     * frontAgreementUrl 报读须知 (string query )
     * gender 性别 (string query )
     * graduationDiscipline 毕业科类 (string query )
     * graduationMajor 毕业专业 (string query )
     * graduationSchool 毕业院校 (string query )
     * graduationTime 毕业时间 (string query )
     * headerTeacher 班主任 (string query )
     * headerTeacherId 班主任id (integer query )
     * id 学籍信息id (integer query )
     * idCardBackPhoto 身份证反面 (string query )
     * idCardFrontPhoto 身份证正面 (string query )
     * idCardNo 身份证号 (string query )
     * ignoreEnrollAdult 本年不报成教 (string query )
     * ignoreEnrollAdultReason 本年不报成教理由 (string query )
     * liveStatus 流失状态 (string query )
     * loseRiskItem 流失风险因素 (string query )
     * loseRiskLevel 流失风险等级 (string query )
     * major 专业 (string query )
     * majorId 专业id (integer query )
     * medicalHistory 病史 (string query )
     * medicalHistoryStatus 是否有病史 (string query )
     * name 姓名 (string query )
     * nation 民族 (string query )
     * oldSchoolRollId 老合同编号 (integer query )
     * originGraduateType 前置学历类型 (string query )
     * otherProtocol 其他协议(多份) (string query )
     * performanceTime 业绩核算时间 (string query )
     * phone 注册手机号 (string query )
     * photo 个人照 (string query )
     * politicalStatus 政治面貌 (string query )
     * preDegreeStatus 前置学历状态 (string query )
     * preHeaderTeacher 前置学历班主任 (string query )
     * preHeaderTeacherPhone 前置学历班主任联系方式 (string query )
     * promiseLetter 家长承诺书 (string query )
     * promiseStatus 是否有家长承诺书 (string query )
     * referralUserId 推荐人id (integer query )
     * referralUserName 推荐人名字 (string query )
     * referralUserPhone 推荐人手机号 (string query )
     * schoolStatus 学籍状态 (string query )
     * serviceAcceptAuditId 后端接收审核人ID (integer query )
     * serviceAcceptAuditName 后端接收审核人 (string query )
     * serviceAcceptAuditTime 校区接收审核时间 (string query )
     * serviceAcceptRefuseRemark 校区接收审核备注 (string query )
     * serviceAcceptStatus 校区接收状态 (string query )
     * serviceApplyTime 申请校区接收时间 (string query )
     * shippingAddress 收件地址 (string query )
     * site 学校 (string query )
     * siteId 学校id (integer query )
     * siteProvince 学校省份 (string query )
     * siteType 学校类型 (string query )
     * sourceFrom 来源详情（招生老师角色包含同行招生老师或者招生老师部门包含电销） (string query )
     * sourceFromDetail 具体来源详情 (string query )
     * tuitionStatus 缴费状态 (string query )
     * userId 用户id (integer query )
     * workingCertificatePhoto 工作证明对应的凭证） (string query )
     * workingCertificatePhotoType 工作证明|市民卡|社保卡照片的具体类型说明 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollContinue/editForFront", p, c)
  },
  schoolRollContinue_editForService: {
    /*
     * 后端编辑
     * address 身份证地址 (string query )
     * adminTeacher 合同负责人 (string query )
     * adminTeacherDepartment 合同负责人部门 (string query )
     * adultExamYear 成考年度 (string query )
     * agreement 协议号 (string query )
     * agreementUrl 报读协议 (string query )
     * auditStep 审核情况 (string query )
     * batch 批次 (string query )
     * bedroom 寝室 (string query )
     * bedroomHead 寝室长 (string query )
     * bedroomId 寝室id (integer query )
     * birth 出生日期 (string query )
     * cadreStatus 是否班团委 (string query )
     * classPositions 班委职务 (string query )
     * classRoom 班级 (string query )
     * classRoomId 班级id (integer query )
     * clueId 线索 (integer query )
     * companyAddress 单位地址 (string query )
     * companyName 单位名称 (string query )
     * contactPhone 联系电话 (string query )
     * continueNoticeConfirmTime 告知书签署时间(继教院） (string query )
     * continueNoticeConfirmUrl 告知书地址(继教院） (string query )
     * contractCancelTime 退费时间 (string query )
     * contractFinishTime 成交时间 (string query )
     * corpsPositions 团委职务 (string query )
     * createTime 报名时间 (string query )
     * denyReason 拒绝原因 (string query )
     * department 合同部门 (string query )
     * departmentId 合同部门ID (integer query )
     * diagnosisInfo 诊断情况概述 (string query )
     * diagnosisProof 诊断证明 (string query )
     * diagnosisStatus 是否有诊断证明 (string query )
     * diplomaNo 毕业证书编号 (string query )
     * diplomaPhoto 毕业证书照片 (string query )
     * discipline 科类 (string query )
     * discountAmount 优惠金额 (number query )
     * discountType 优惠类型 (string query )
     * eduAuditName 招办老师(如果审核人为空则取学校招办老师字段) (string query )
     * eduAuditTime 招办审核时间 (string query )
     * eduRemark 教务备注 (string query )
     * educationLevel 学历层次 (string query )
     * educationNetCertificatePhoto 学历电子注册备案表（专升本必填） (string query )
     * emergencyContactName 紧急联系人 (string query )
     * emergencyContactPhone 紧急联系电话 (string query )
     * enrollByOtherStation 学历是否已报他处(继教院) (string query )
     * enrollByOtherStationUrl 学历是否已报他处凭证 (string query )
     * enrollLevel 层次 (string query )
     * enrollReason 报名原因 (string query )
     * enrollRemark 招生老师备注 (string query )
     * enrollTeacher 招生老师 (string query )
     * enrollTeacherDepartment 招生老师部门 (string query )
     * enrollTeacherId 招生老师id (integer query )
     * enrollTeacherPosition 招生老师角色 (string query )
     * enterSchoolDate 报到时间 (string query )
     * enterprise 校企学生单位（不可编辑，通过企业扫码报名的学生特有） (string query )
     * extraFile 报名表 (string query )
     * focusInfo 基本情况概述 (string query )
     * focusStatus 是否重点关注 (string query )
     * focusType 重点关注类型 (string query )
     * frontAgreementUrl 报读须知 (string query )
     * gender 性别 (string query )
     * graduationDiscipline 毕业科类 (string query )
     * graduationMajor 毕业专业 (string query )
     * graduationSchool 毕业院校 (string query )
     * graduationTime 毕业时间 (string query )
     * headerTeacher 班主任 (string query )
     * headerTeacherId 班主任id (integer query )
     * id 学籍信息id (integer query )
     * idCardBackPhoto 身份证反面 (string query )
     * idCardFrontPhoto 身份证正面 (string query )
     * idCardNo 身份证号 (string query )
     * ignoreEnrollAdult 本年不报成教 (string query )
     * ignoreEnrollAdultReason 本年不报成教理由 (string query )
     * liveStatus 流失状态 (string query )
     * lodgingStatus 是否住宿 (string query )
     * loseRiskItem 流失风险因素 (string query )
     * loseRiskLevel 流失风险等级 (string query )
     * major 专业 (string query )
     * majorId 专业id (integer query )
     * medicalHistory 病史 (string query )
     * medicalHistoryStatus 是否有病史 (string query )
     * name 姓名 (string query )
     * nation 民族 (string query )
     * oldSchoolRollId 老合同编号 (integer query )
     * originGraduateType 前置学历类型 (string query )
     * otherProtocol 其他协议(多份) (string query )
     * performanceTime 业绩核算时间 (string query )
     * phone 注册手机号 (string query )
     * photo 个人照 (string query )
     * politicalStatus 政治面貌 (string query )
     * promiseLetter 家长承诺书 (string query )
     * promiseStatus 是否有家长承诺书 (string query )
     * referralUserId 推荐人id (integer query )
     * referralUserName 推荐人名字 (string query )
     * referralUserPhone 推荐人手机号 (string query )
     * rollGrade 学籍年级 (string query )
     * schoolStatus 学籍状态 (string query )
     * secondEmergencyContactName 紧急联系人2姓名 (string query )
     * secondEmergencyContactPhone 紧急联系人2电话 (string query )
     * selfTaughtSchoolRollId 自考合同编号 (integer query )
     * serviceRemark 服务备注 (string query )
     * shippingAddress 收件地址 (string query )
     * site 学校 (string query )
     * siteId 学校id (integer query )
     * siteProvince 学校省份 (string query )
     * siteType 学校类型 (string query )
     * sourceFrom 来源详情（招生老师角色包含同行招生老师或者招生老师部门包含电销） (string query )
     * studentNo 学号 (string query )
     * tuitionStatus 缴费状态 (string query )
     * userId 用户id (integer query )
     * workingCertificatePhoto 工作证明 (string query )
     * workingCertificatePhotoType 工作证明等照片的具体类型说明 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollContinue/editForService", p, c)
  },
  schoolRollContinue_exportForAudit: {
    /*
     * 招办审核导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/exportForAudit", p, c)
  },
  schoolRollContinue_exportForCont: {
    /*
     * 导出(职教学校平台)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/exportForCont", p, c)
  },
  schoolRollContinue_exportForService: {
    /*
     * 服务学生列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/exportForService", p, c)
  },
  schoolRollContinue_exportForServiceAccept: {
    /*
     * 后端接收服务导出
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollContinue/exportForServiceAccept",
        p,
        c
      )
  },
  schoolRollContinue_exportTransaction: {
    /*
     * 异动列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/exportTransaction", p, c)
  },
  schoolRollContinue_getContinueNoticeConfirmInfo: {
    /*
     * 获取继教院告知书内容
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollContinue/getContinueNoticeConfirmInfo",
        p,
        c
      )
  },
  schoolRollContinue_graduate: {
    /*
     * 单个毕业
     * adultHeaderTeacherId 成教班主任 (integer query )
     * graduateTime 毕业时间 (string query required)
     * schoolRollId 合同id (integer query required)
     * selfTaughtHeaderTeacherId 自考班主任 (integer query )
     */
    put: (p, c) => $.put("/api/ems/education/schoolRollContinue/graduate", p, c)
  },
  schoolRollContinue_listAdultEnrollInfo: {
    /*
     * 获取成教录取信息
     * schoolRollId 学籍id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/listAdultEnrollInfo", p, c)
  },
  schoolRollContinue_listForAudit: {
    /*
     * 招办审核列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/listForAudit", p, c)
  },
  schoolRollContinue_listForCont: {
    /*
     * 列表(职教学校平台)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/listForCont", p, c)
  },
  schoolRollContinue_listForService: {
    /*
     * 服务学生列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/listForService", p, c)
  },
  schoolRollContinue_listForServiceAccept: {
    /*
     * 后端接收服务列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/listForServiceAccept", p, c)
  },
  schoolRollContinue_listSimpleStudent: {
    /*
     * 根据是否自考生查询某班级学生列表
     * classRoomIds 班级ids (array query required)
     * type 类型：自考生1、非自考生2,全部则不传 (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/listSimpleStudent", p, c)
  },
  schoolRollContinue_listStudentForChargeSite: {
    /*
     * 根据负责的学校和姓名获取学生列表
     * bedroomId 宿舍id (integer query )
     * classRoomId 班级id (integer query )
     * name 姓名 (string query )
     * siteId 学校id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollContinue/listStudentForChargeSite",
        p,
        c
      )
  },
  schoolRollContinue_listStudentForTeacher: {
    /*
     * 学生列表(讲师)
     * classRoomId 班级id (string query required)
     * name 姓名 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/listStudentForTeacher", p, c)
  },
  schoolRollContinue_listTransaction: {
    /*
     * 异动列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/listTransaction", p, c)
  },
  schoolRollContinue_listUnAssign: {
    /*
     * 未分配学生列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/listUnAssign", p, c)
  },
  schoolRollContinue_parentSignInInfo: {
    /*
     * 家长登录情况
     * headerTeacherId 班主任id (integer query )
     * siteIds 学校id (array query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/parentSignInInfo", p, c)
  },
  schoolRollContinue_removeForCont: {
    /*
     * 删除(职教学校平台)
     * schoolRollId 合同id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/education/schoolRollContinue/removeForCont", p, c)
  },
  schoolRollContinue_searchEnrollInfo: {
    /*
     * 查询职教合同录取情况
     * idCardNo 身份证 (string query required)
     * siteId 学校id：江财1783772064219987969 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/searchEnrollInfo", p, c)
  },
  schoolRollContinue_submitForBackend: {
    /*
     * 后端服务接收学生-申请
     * id id (integer query required)
     * remark 备注 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollContinue/submitForBackend", p, c)
  },
  schoolRollContinue_updateEnrollByOtherStation: {
    /*
     * 学历是否已报他处
     * enrollByOtherStation 是否 (string query required)
     * enrollByOtherStationUrl 已报他处凭证 (string query )
     * schoolRollId 合同编号 (integer query required)
     */
    put: (p, c) =>
      $.put(
        "/api/ems/education/schoolRollContinue/updateEnrollByOtherStation",
        p,
        c
      )
  },
  schoolRollContinue_updateNotEnrollByAdult: {
    /*
     * 本年不报成教
     * ignoreEnrollAdult 本年不报成教（是否） (string query required)
     * reason 本年不报考(下拉) (string query )
     * schoolRollId 合同id (integer query required)
     */
    put: (p, c) =>
      $.put(
        "/api/ems/education/schoolRollContinue/updateNotEnrollByAdult",
        p,
        c
      )
  },
  schoolRollContinue_updateSchoolingStatus: {
    /*
     * 单个更新在读状态
     * enterSchoolDate 报道时间 (string query required)
     * schoolRollId 学籍id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollContinue/updateSchoolingStatus", p, c)
  },
  schoolRollContinue_uploadChangeDormitory: {
    /*
     * 导入更换寝室
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/schoolRollContinue/uploadChangeDormitory",
        p,
        c
      )
  },
  schoolRollContinue_uploadContinueNoticeConfirm: {
    /*
     * 上传继教院告知书
     * agreementUrl 报读地址 (string query required)
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put(
        "/api/ems/education/schoolRollContinue/uploadContinueNoticeConfirm",
        p,
        c
      )
  },
  schoolRollContinue_uploadContinueNoticeConfirmForClient: {
    /*
     * C端上传告知书（学生签名）
     * id id (integer query required)
     * signData 签名图片，png文件，base64值 (string query required)
     */
    put: (p, c) =>
      $.put(
        "/api/ems/education/schoolRollContinue/uploadContinueNoticeConfirmForClient",
        p,
        c
      )
  },
  schoolRollContinue_uploadForCont: {
    /*
     * 导入(职教学校平台)
     * file file (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollContinue/uploadForCont", p, c)
  },
  schoolRollContinue_uploadGraduate: {
    /*
     * 批量导入毕业名单
     * file file (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollContinue/uploadGraduate", p, c)
  },
  schoolRollContinue_uploadSchooling: {
    /*
     * 批量导入在读名单
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollContinue/uploadSchooling", p, c)
  },
  schoolRollContinue_uploadSomeInfoForContinue: {
    /*
     * 继教院-批量导入修改信息
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/schoolRollContinue/uploadSomeInfoForContinue",
        p,
        c
      )
  },

  /**
   * 学生信息勘误
   */
  schoolRollInfoModify_apply: {
    /*
     * 申请（服务-学生详情-在读状态）
     * newIdCardBackPhoto 新身份证背面照片 (string query )
     * newIdCardFrontPhoto 新身份证正面照片 (string query )
     * newIdCardNo 新身份证号 (string query )
     * newName 新学生姓名 (string query )
     * newNation 新民族 (string query )
     * newPoliticalStatus 新政治面貌 (string query )
     * remark 申请备注 (string query )
     * schoolRollId schoolRollId (integer query )
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollInfoModify/apply", p, c)
  },
  schoolRollInfoModify_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollInfoModify/details", p, c)
  },
  schoolRollInfoModify_finish: {
    /*
     * 办结
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/education/schoolRollInfoModify/finish", p, c)
  },
  schoolRollInfoModify_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/education/schoolRollInfoModify/list", p, c)
  },
  schoolRollInfoModify_listSimple: {
    /*
     * 简易列表
     * schoolRollId 学籍id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollInfoModify/listSimple", p, c)
  },
  schoolRollInfoModify_update: {
    /*
     * 编辑
     * id id (integer query required)
     * newIdCardBackPhoto 新身份证背面照片 (string query )
     * newIdCardFrontPhoto 新身份证正面照片 (string query )
     * newIdCardNo 新身份证号 (string query )
     * newName 新学生姓名 (string query )
     * newNation 新民族 (string query )
     * newPoliticalStatus 新政治面貌 (string query )
     * remark 申请备注 (string query )
     */
    put: (p, c) => $.put("/api/ems/education/schoolRollInfoModify/update", p, c)
  },

  /**
   * 新生注册
   */
  schoolRollRegistry_confirmForClient: {
    /*
     * 学生确认或编辑（被打回）新生注册信息
     * chsiImage 学信网截图 (string query required)
     * confirmStatus 确认状态，已确认|反馈错误 (string query required)
     * id 新生注册信息返回的ID (integer query )
     * reportExtraUrl 反馈错误附件 (string query )
     * reportReason 反馈错误描述 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollRegistry/confirmForClient", p, c)
  },
  schoolRollRegistry_confirmForManager: {
    /*
     * 班主任确认新生注册信息
     * chsiImage 学信网截图 (string query required)
     * confirmStatus 确认状态，已确认|反馈错误 (string query required)
     * id ID (integer query )
     * reportExtraUrl 反馈错误附件 (string query )
     * reportReason 反馈错误描述 (string query )
     * schoolRollId schoolRollId (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollRegistry/confirmForManager", p, c)
  },
  schoolRollRegistry_countUnFinishedForMainPage: {
    /*
     * 未进行学籍核对数量
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollRegistry/countUnFinishedForMainPage",
        p,
        c
      )
  },
  schoolRollRegistry_details: {
    /*
     * 详情
     * schoolRollId 合同编号 (integer query )
     */
    get: (p, c) => $.get("/api/ems/education/schoolRollRegistry/details", p, c)
  },
  schoolRollRegistry_eduDispose: {
    /*
     * 教务处理反馈错误
     * extraUrl 处理附件 (string query )
     * finishStatus 状态：未完结|已完结 (string query required)
     * id ID (integer query required)
     * resultContent 处理内容 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollRegistry/eduDispose", p, c)
  },
  schoolRollRegistry_eduRefuse: {
    /*
     * 教务打回
     * id ID (integer query required)
     * refuseReason 打回理由 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollRegistry/eduRefuse", p, c)
  },
  schoolRollRegistry_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/education/schoolRollRegistry/export", p, c)
  },
  schoolRollRegistry_infoForClient: {
    /*
     * 学生获取新生注册信息
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollRegistry/infoForClient", p, c)
  },
  schoolRollRegistry_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/education/schoolRollRegistry/list", p, c)
  },
  schoolRollRegistry_listEduDispose: {
    /*
     * 教务处理记录
     * id ID (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollRegistry/listEduDispose", p, c)
  },
  schoolRollRegistry_refuse: {
    /*
     * 班主任打回新生注册信息
     * id ID (integer query required)
     * refuseReason 打回理由 (string query required)
     */
    put: (p, c) => $.put("/api/ems/education/schoolRollRegistry/refuse", p, c)
  },

  /**
   * 合同自考信息表
   */
  schoolRollSelfTaught_assign: {
    /*
     * 分配班主任
     * headerTeacherId 班主任id (integer query required)
     * ids 服务信息id (array query required)
     */
    put: (p, c) => $.put("/api/ems/education/schoolRollSelfTaught/assign", p, c)
  },
  schoolRollSelfTaught_batchChangeHeaderTeacher: {
    /*
     * 批量更换班主任
     * headerTeacherId 班主任id (integer query required)
     * ids 服务id (array query required)
     */
    put: (p, c) =>
      $.put(
        "/api/ems/education/schoolRollSelfTaught/batchChangeHeaderTeacher",
        p,
        c
      )
  },
  schoolRollSelfTaught_detailsForFront: {
    /*
     * 前端详情（报名确认、招生统计、招办审核）
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/detailsForFront", p, c)
  },
  schoolRollSelfTaught_detailsForService: {
    /*
     * 后端详情
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/detailsForService", p, c)
  },
  schoolRollSelfTaught_downloadGraduateTimeMould: {
    /*
     * 下载批量导入毕业时间模版
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollSelfTaught/downloadGraduateTimeMould",
        p,
        c
      )
  },
  schoolRollSelfTaught_downloadSchoolingMould: {
    /*
     * 在读名单模版
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollSelfTaught/downloadSchoolingMould",
        p,
        c
      )
  },
  schoolRollSelfTaught_editForFront: {
    /*
     * 前端编辑（报名确认、招生统计、招办审核）
     * address 身份证地址 (string query )
     * adminTeacher 合同负责人 (string query )
     * adminTeacherDepartment 合同负责人部门 (string query )
     * adminTeacherId 合同负责人id (integer query )
     * agreement 协议号 (string query )
     * agreementTime 报读协议签署时间 (string query )
     * agreementUrl 报读协议 (string query )
     * auditStep 审核情况 (string query )
     * batch 批次 (string query )
     * birth 出生日期 (string query )
     * certificatePhoto 特殊证件(药学护理证件|人社证书的特殊证件) (string query )
     * clueCirculateApplyId 线索流转人id (integer query )
     * clueCirculateApplyName 线索流转人 (string query )
     * clueCreator 线索流转人 (string query )
     * clueCreatorId 线索流转人id (integer query )
     * clueId 线索 (integer query )
     * clueOriginChannel 线索来源渠道 (string query )
     * clueOriginDetail 线索具体来源 (string query )
     * companyAddress 单位地址 (string query )
     * companyName 单位名称 (string query )
     * contactPhone 联系电话 (string query )
     * contractCancelTime 退费时间 (string query )
     * contractFinishTime 成交时间 (string query )
     * contractFinishType 合同成交类型 (string query )
     * degreeApply 学位申请情况 (string query )
     * degreeApplyResult 学位申请结果 (string query )
     * denyReason 拒绝原因 (string query )
     * department 合同部门 (string query )
     * departmentId 合同部门id (integer query )
     * diplomaNo 毕业证书编号 (string query )
     * diplomaPhoto 毕业证 (string query )
     * discipline 科类 (string query )
     * discountAmount 优惠金额 (number query )
     * discountType 优惠类型 (string query )
     * eduAuditName 招办老师(如果审核人为空则取学校招办老师字段) (string query )
     * eduAuditTime 招办审核时间 (string query )
     * educationLevel 学历层次 (string query )
     * educationNetCertificatePhoto 学历电子注册备案表（专升本必填） (string query )
     * emergencyContactName 紧急联系人 (string query )
     * emergencyContactPhone 紧急联系电话 (string query )
     * enrollLevel 层次 (string query )
     * enrollRemark 招生老师备注 (string query )
     * enrollTeacher 招生老师 (string query )
     * enrollTeacherDepartment 招生老师部门 (string query )
     * enrollTeacherId 招生老师id (integer query )
     * enrollTeacherPosition 招生老师角色 (string query )
     * enrollTime 报名时间 (string query )
     * examRegister 考试院注册 (string query )
     * experience 是否10天体验期学员-自考 (string query )
     * frontAgreementUrl 报读须知 (string query )
     * gender 性别 (string query )
     * graduationDiscipline 毕业科类 (string query )
     * graduationMajor 毕业专业 (string query )
     * graduationSchool 毕业院校 (string query )
     * graduationTime 毕业时间 (string query )
     * headerTeacher 班主任 (string query )
     * headerTeacherId 班主任id (integer query )
     * id 学籍信息id (integer query )
     * idCardBackPhoto 身份证反面 (string query )
     * idCardFrontPhoto 身份证正面 (string query )
     * idCardNo 身份证号 (string query )
     * liveStatus 流失状态 (string query )
     * loan 是否助学贷款学员-自考 (string query )
     * loseRiskLevel 流失风险等级 (string query )
     * major 专业 (string query )
     * majorId 专业id (integer query )
     * multifunction 是否一报双考学员-自考 (string query )
     * name 姓名 (string query )
     * nation 民族 (string query )
     * oldSchoolRollId 老合同编号 (integer query )
     * performanceTime 业绩核算时间 (string query )
     * phone 注册手机号 (string query )
     * photo 个人照 (string query )
     * politicalStatus 政治面貌 (string query )
     * preDegreeStatus 前置学历状态 (string query )
     * preHeaderTeacher 前置学历班主任 (string query )
     * preHeaderTeacherPhone 前置学历班主任联系方式 (string query )
     * referralUserId 推荐人id (integer query )
     * referralUserName 推荐人名字 (string query )
     * referralUserPhone 推荐人手机号 (string query )
     * registerArea 注册地 (string query )
     * schoolStatus 学籍状态 (string query )
     * shippingAddress 收件地址 (string query )
     * site 学校 (string query )
     * siteId 学校id (integer query )
     * siteProvince 学校省份 (string query )
     * siteType 学校类型 (string query )
     * sourceFrom 来源详情（招生老师角色包含同行招生老师或者招生老师部门包含电销） (string query )
     * sourceFromDetail 具体来源详情 (string query )
     * tuitionStatus 缴费状态 (string query )
     * userId 用户id (integer query )
     * workingCertificatePhoto 工作证明对应的凭证） (string query )
     * workingCertificatePhotoType 工作证明|市民卡|社保卡照片的具体类型说明 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollSelfTaught/editForFront", p, c)
  },
  schoolRollSelfTaught_editForService: {
    /*
     * 后端编辑
     * address 身份证地址 (string query )
     * adminTeacher 合同负责人 (string query )
     * adminTeacherDepartment 合同负责人部门 (string query )
     * adultExamYear 成考年度 (string query )
     * adultSchoolRollList[0].id id (integer query )
     * adultSchoolRollList[0].name 名字 (string query )
     * agreement 协议号 (string query )
     * agreementUrl 报读协议 (string query )
     * auditStep 审核情况 (string query )
     * batch 批次 (string query )
     * birth 出生日期 (string query )
     * clueId 线索 (integer query )
     * companyAddress 单位地址 (string query )
     * companyName 单位名称 (string query )
     * contactPhone 联系电话 (string query )
     * contractCancelTime 退费时间 (string query )
     * contractFinishTime 成交时间 (string query )
     * createTime 报名时间 (string query )
     * degreeApply 学位申请情况 (string query )
     * degreeApplyResult 学位申请结果 (string query )
     * denyReason 拒绝原因 (string query )
     * department 合同部门 (string query )
     * departmentId 合同部门ID (integer query )
     * diplomaNo 毕业证书编号 (string query )
     * diplomaPhoto 毕业证书照片 (string query )
     * discipline 科类 (string query )
     * discountAmount 优惠金额 (number query )
     * discountType 优惠类型 (string query )
     * eduAuditName 招办老师(如果审核人为空则取学校招办老师字段) (string query )
     * eduAuditTime 招办审核时间 (string query )
     * eduRemark 教务备注 (string query )
     * educationLevel 学历层次 (string query )
     * educationNetCertificatePhoto 学历电子注册备案表（专升本必填） (string query )
     * emergencyContactName 紧急联系人 (string query )
     * emergencyContactPhone 紧急联系电话 (string query )
     * enrollLevel 层次 (string query )
     * enrollRemark 招生老师备注 (string query )
     * enrollTeacher 招生老师 (string query )
     * enrollTeacherDepartment 招生老师部门 (string query )
     * enrollTeacherId 招生老师id (integer query )
     * enrollTeacherPosition 招生老师角色 (string query )
     * enterprise 校企学生单位（不可编辑，通过企业扫码报名的学生特有） (string query )
     * examRegister 考试院注册 (string query )
     * experience 是否10天体验期学员-自考 (string query )
     * frontAgreementUrl 报读须知 (string query )
     * gender 性别 (string query )
     * graduationDiscipline 毕业科类 (string query )
     * graduationMajor 毕业专业 (string query )
     * graduationSchool 毕业院校 (string query )
     * graduationTime 毕业时间 (string query )
     * headerTeacher 班主任 (string query )
     * headerTeacherId 班主任id (integer query )
     * id 学籍信息id (integer query )
     * idCardBackPhoto 身份证反面 (string query )
     * idCardFrontPhoto 身份证正面 (string query )
     * idCardNo 身份证号 (string query )
     * liveStatus 流失状态 (string query )
     * loan 是否助学贷款学员-自考 (string query )
     * loseRiskLevel 流失风险等级 (string query )
     * major 专业 (string query )
     * majorId 专业id (integer query )
     * multifunction 是否一报双考学员-自考 (string query )
     * name 姓名 (string query )
     * nation 民族 (string query )
     * oldSchoolRollId 老合同编号 (integer query )
     * performanceTime 业绩核算时间 (string query )
     * phone 注册手机号 (string query )
     * photo 个人照 (string query )
     * referralUserId 推荐人id (integer query )
     * referralUserName 推荐人名字 (string query )
     * referralUserPhone 推荐人手机号 (string query )
     * registerArea 注册地 (string query )
     * rollGrade 学籍年级 (string query )
     * schoolStatus 学籍状态 (string query )
     * serviceRemark 服务备注 (string query )
     * shippingAddress 收件地址 (string query )
     * site 学校 (string query )
     * siteId 学校id (integer query )
     * siteProvince 学校省份 (string query )
     * siteType 学校类型 (string query )
     * sourceFrom 来源详情（招生老师角色包含同行招生老师或者招生老师部门包含电销） (string query )
     * tuitionStatus 缴费状态 (string query )
     * userId 用户id (integer query )
     * workingCertificatePhoto 工作证明 (string query )
     * workingCertificatePhotoType 工作证明等照片的具体类型说明 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollSelfTaught/editForService", p, c)
  },
  schoolRollSelfTaught_exportCredit: {
    /*
     * 学分列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/exportCredit", p, c)
  },
  schoolRollSelfTaught_exportForAudit: {
    /*
     * 资料审核列表导出（自考）
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/exportForAudit", p, c)
  },
  schoolRollSelfTaught_exportForService: {
    /*
     * 服务学生列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/exportForService", p, c)
  },
  schoolRollSelfTaught_exportForTeacher: {
    /*
     * 自考学生列表（讲师）导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/exportForTeacher", p, c)
  },
  schoolRollSelfTaught_listCredit: {
    /*
     * 学分列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/listCredit", p, c)
  },
  schoolRollSelfTaught_listForAudit: {
    /*
     * 资料审核列表（自考）
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/listForAudit", p, c)
  },
  schoolRollSelfTaught_listForService: {
    /*
     * 服务学生列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/listForService", p, c)
  },
  schoolRollSelfTaught_listForTeacher: {
    /*
     * 自考学生列表（讲师）
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/listForTeacher", p, c)
  },
  schoolRollSelfTaught_listUnAssign: {
    /*
     * 未分配学生列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/listUnAssign", p, c)
  },
  schoolRollSelfTaught_listUnfinishCourse: {
    /*
     * 未完成课程列表
     * courseType 课程类型：必修课程、公共课程 (string query required)
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/listUnfinishCourse", p, c)
  },
  schoolRollSelfTaught_restore: {
    /*
     * 恢复
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/restore", p, c)
  },
  schoolRollSelfTaught_uploadGraduateTime: {
    /*
     * 批量导入毕业时间
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollSelfTaught/uploadGraduateTime", p, c)
  },
  schoolRollSelfTaught_uploadSchooling: {
    /*
     * 导入在读名单
     * file file (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollSelfTaught/uploadSchooling", p, c)
  },

  /**
   * 合同（学籍）异动
   */
  schoolRollTransaction_applyForEducation: {
    /*
     * 教务异动申请
     * adultExitFlag 成教合同是否退学（继教院退学时候选择） (string query )
     * applyRemark 备注 (string query )
     * batch 新批次, 转批次才有 (string query )
     * dropoutsExtraFile 退学视频附件 (string query )
     * endTime 休学结束时间 (string query )
     * extraFile 附件 (string query )
     * giveUpReason 退学原因，自考下拉 (string query )
     * majorId 专业id (integer query )
     * reason 异动理由 (string query )
     * rollGrade 学籍年级 (string query )
     * schoolRollId 学籍id (integer query required)
     * tradeType 异动类型：休学、退学、转专业、复学, 转批次(自考特有) (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollTransaction/applyForEducation", p, c)
  },
  schoolRollTransaction_applyForEnroll: {
    /*
     * 招办异动申请
     * account 账号 (string query )
     * accountNick 账号昵称 (string query )
     * accountType 账号类型 (string query )
     * amount 不读退款金额 (number query )
     * applyRemark 备注 (string query )
     * batch 批次 (string query )
     * dropoutsExtraFile 退学视频附件 (string query )
     * extraFile 附件 (string query )
     * giveUpReason 不读理由，职教下拉 (string query )
     * majorId 专业id (integer query )
     * schoolRollId 学籍id (integer query required)
     * sourceService 是否服务管理发起招办异动 (string query )
     * tradeType 异动类型：不读，转校转专业，转批次 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollTransaction/applyForEnroll", p, c)
  },
  schoolRollTransaction_autoCheckAdminTeacherAuditDelay: {
    /*
     * 测试-autoCheckAdminTeacherAuditDelay
     */
    put: (p, c) =>
      $.put(
        "/api/ems/education/schoolRollTransaction/autoCheckAdminTeacherAuditDelay",
        p,
        c
      )
  },
  schoolRollTransaction_batchLeave: {
    /*
     * 批量不读
     * applyRemark 备注 (string query )
     * schoolRollIds 学籍id (array query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollTransaction/batchLeave", p, c)
  },
  schoolRollTransaction_checkNeedPayFee: {
    /*
     * 检测转批次是否需要缴费
     * newBatch 新批次 (string query required)
     * schoolRollId schoolRollId (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollTransaction/checkNeedPayFee", p, c)
  },
  schoolRollTransaction_details: {
    /*
     * 详情
     * getMoney 是否获取返款金额和优惠等, 异动类型为不读的时候传1 (integer query )
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollTransaction/details", p, c)
  },
  schoolRollTransaction_downloadMould: {
    /*
     * 批量异动模版下载
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollTransaction/downloadMould", p, c)
  },
  schoolRollTransaction_editExtraFile: {
    /*
     * 编辑附件
     * extraFile 附件 (string query required)
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollTransaction/editExtraFile", p, c)
  },
  schoolRollTransaction_eduEdit: {
    /*
     * 编辑办结
     * id id (integer query required)
     * receivedPaper 是否收到纸质稿 (string query required)
     * schoolFinished 高校手续是否办结 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollTransaction/eduEdit", p, c)
  },
  schoolRollTransaction_exportForDoing: {
    /*
     * 异动审核列表导出-内部管理-基础平台
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollTransaction/exportForDoing", p, c)
  },
  schoolRollTransaction_exportPageForEdu: {
    /*
     * 教务异动记录列表导出-学籍管理-学历教育
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollTransaction/exportPageForEdu", p, c)
  },
  schoolRollTransaction_exportPageForEduForPeer: {
    /*
     * 教务异动记录列表导出-基础平台-同行管理-教务异动记录
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollTransaction/exportPageForEduForPeer",
        p,
        c
      )
  },
  schoolRollTransaction_exportPageForEnroll: {
    /*
     * 招办异动记录列表导出-招办管理-学历教育
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollTransaction/exportPageForEnroll",
        p,
        c
      )
  },
  schoolRollTransaction_exportPageForEnrollForPeer: {
    /*
     * 招办异动记录列表导出-基础平台-同行管理-招办异动记录
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollTransaction/exportPageForEnrollForPeer",
        p,
        c
      )
  },
  schoolRollTransaction_listDoing: {
    /*
     * 进行中异动
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollTransaction/listDoing", p, c)
  },
  schoolRollTransaction_listPageForEdu: {
    /*
     * 教务异动记录列表-学籍管理-学历教育
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollTransaction/listPageForEdu", p, c)
  },
  schoolRollTransaction_listPageForEduForPeer: {
    /*
     * 教务异动记录列表-基础平台-同行管理-教务异动记录
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollTransaction/listPageForEduForPeer",
        p,
        c
      )
  },
  schoolRollTransaction_listPageForEnroll: {
    /*
     * 招办异动记录列表-招办管理-学历教育
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollTransaction/listPageForEnroll", p, c)
  },
  schoolRollTransaction_listPageForEnrollForPeer: {
    /*
     * 招办异动记录列表-基础平台-同行管理-招办异动记录
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollTransaction/listPageForEnrollForPeer",
        p,
        c
      )
  },
  schoolRollTransaction_listSimple: {
    /*
     * 简易异动列表
     * schoolRollId 学籍id (integer query required)
     * status 审批状态:通过 审核中 拒绝 (string query )
     * tradeType 具体类型 (string query )
     * type 类型：招办异动，教务异动 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollTransaction/listSimple", p, c)
  },
  schoolRollTransaction_sameIndustryApplyForEnroll: {
    /*
     * 招办异动申请-同行
     * applyRemark 备注 (string query )
     * batch 批次 (string query )
     * majorId 专业id (integer query )
     * schoolRollId 学籍id (integer query required)
     * tradeType 异动类型：不读，转校转专业，转批次 (string query required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/schoolRollTransaction/sameIndustryApplyForEnroll",
        p,
        c
      )
  },
  schoolRollTransaction_uploadEduFile: {
    /*
     * 教务上传退学时的文件
     * eduFile 退学时教务上传的文件 (string query required)
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollTransaction/uploadEduFile", p, c)
  },

  /**
   * 增值服务
   */
  schoolRollVip_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/education/schoolRollVip/details", p, c)
  },
  schoolRollVip_downloadMould: {
    /*
     * 下载批量更新状态模版
     */
    get: (p, c) => $.get("/api/ems/education/schoolRollVip/downloadMould", p, c)
  },
  schoolRollVip_downloadMouldVipStudent: {
    /*
     * 下载批量导入VIP服务学生模板
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollVip/downloadMouldVipStudent", p, c)
  },
  schoolRollVip_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/education/schoolRollVip/export", p, c)
  },
  schoolRollVip_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/education/schoolRollVip/list", p, c)
  },
  schoolRollVip_listBySchoolRolId: {
    /*
     * 根据合同编号查询简单列表
     * schoolRollId 合同编号 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollVip/listBySchoolRolId", p, c)
  },
  schoolRollVip_listRemark: {
    /*
     * 备注记录列表
     * id 列表ID (integer query required)
     */
    get: (p, c) => $.get("/api/ems/education/schoolRollVip/listRemark", p, c)
  },
  schoolRollVip_save: {
    /*
     * 添加
     * actualAmount 实收金额 (number query required)
     * attach 附件 (string query required)
     * commitTime 提交时间 (string query required)
     * configIds 辅导配置ID (array query required)
     * contentDetail 具体内容 (string query )
     * endTime 结束时间 (string query )
     * payAmount 支付金额 (number query )
     * payTime 支付时间 (string query )
     * receiveTime 接收时间 (string query required)
     * remark 备注内容 (string query )
     * schoolRollId 合同编号 (integer query required)
     * status 状态 (string query required)
     */
    post: (p, c) => $.post("/api/ems/education/schoolRollVip/save", p, c)
  },
  schoolRollVip_saveRemark: {
    /*
     * 添加备注
     * id id (integer query required)
     * remark 具体内容 (string query )
     */
    put: (p, c) => $.put("/api/ems/education/schoolRollVip/saveRemark", p, c)
  },
  schoolRollVip_update: {
    /*
     * 编辑
     * actualAmount 实收金额 (number query required)
     * attach 附件） (string query required)
     * id id (integer query required)
     * payAmount 支付金额 (number query required)
     * payTime 支付时间 (string query required)
     * status 状态 (string query required)
     */
    put: (p, c) => $.put("/api/ems/education/schoolRollVip/update", p, c)
  },
  schoolRollVip_updateStatus: {
    /*
     * 批量更新状态
     * ids 列表ID (array query required)
     * status 状态 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollVip/updateStatus", p, c)
  },
  schoolRollVip_uploadUpdateStatus: {
    /*
     * 批量导入更新状态
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollVip/uploadUpdateStatus", p, c)
  },
  schoolRollVip_uploadVipStudent: {
    /*
     * 批量导入VIP服务学生
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollVip/uploadVipStudent", p, c)
  },

  /**
   * vip辅导配置
   */
  schoolRollVipConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/education/schoolRollVipConfig/list", p, c)
  },
  schoolRollVipConfig_listConfigBySchoolRollId: {
    /*
     * 根据合同编号查询可选配置列表
     * schoolRollId 合同编号 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollVipConfig/listConfigBySchoolRollId",
        p,
        c
      )
  },
  schoolRollVipConfig_save: {
    /*
     * 添加
     * ableStatus 启用状态 (string query required)
     * content 辅导内容 (string query required)
     * price 价格 (number query required)
     * siteIds 学校ID列表 (array query required)
     */
    post: (p, c) => $.post("/api/ems/education/schoolRollVipConfig/save", p, c)
  },
  schoolRollVipConfig_update: {
    /*
     * 编辑
     * ableStatus 启用状态 (string query required)
     * content 辅导内容 (string query required)
     * id id (integer query )
     * price 价格 (number query required)
     * siteId 学校ID (integer query required)
     */
    put: (p, c) => $.put("/api/ems/education/schoolRollVipConfig/update", p, c)
  },

  /**
   * 成教学生课程
   */
  studentCourse_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/education/studentCourse/export", p, c)
  },
  studentCourse_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/education/studentCourse/list", p, c)
  },

  /**
   * 学习记录
   */
  study_record_detail: {
    /*
     * 详情
     * courseId 课程ID (integer query required)
     * userId userId (integer query required)
     */
    get: (p, c) => $.get("/api/ems/education/study/record/detail", p, c)
  },
  study_record_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/education/study/record/export", p, c)
  },
  study_record_exportDetail: {
    /*
     * 详情导出
     * term 学期 (integer query )
     */
    get: (p, c) => $.get("/api/ems/education/study/record/exportDetail", p, c)
  },
  study_record_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/education/study/record/list", p, c)
  },
  study_record_updateStudyLengthTemp: {
    /*
     * 作弊方法
     * lowPer 最低完成比例 (number query required)
     * randomNum 随机增加范围 (integer query )
     * schoolRollId 合同编号 (integer query )
     * siteId 学校ID (integer query )
     * term 学期 (integer query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/study/record/updateStudyLengthTemp", p, c)
  },

  /**
   * 授课安排
   */
  teachPlan_assignAdultTeacher: {
    /*
     * 分配授课老师
     * adultTeacherId 成教老师id (integer query required)
     * ids 非列表ids (array query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/teachPlan/assignAdultTeacher", p, c)
  },
  teachPlan_batchRemove: {
    /*
     * 批量删除
     * ids id列表 (array query required)
     */
    delete: (p, c) => $.delete("/api/ems/education/teachPlan/batchRemove", p, c)
  },
  teachPlan_detail_detail: {
    /*
     * 签到详情
     * id ID (integer query required)
     */
    get: (p, c) => $.get("/api/ems/education/teachPlan/detail/detail", p, c)
  },
  teachPlan_detail_downloadMould: {
    /*
     * 下载模板
     */
    get: (p, c) =>
      $.get("/api/ems/education/teachPlan/detail/downloadMould", p, c)
  },
  teachPlan_detail_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/education/teachPlan/detail/export", p, c)
  },
  teachPlan_detail_exportExcel: {
    /*
     * 导出签到表
     * season 春秋(下拉) (string query required)
     * teachPlanRecordIds 外层ID (array query required)
     * year 年度 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/teachPlan/detail/exportExcel", p, c)
  },
  teachPlan_detail_getForClient: {
    /*
     * 学生端-我的列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/teachPlan/detail/getForClient", p, c)
  },
  teachPlan_detail_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/education/teachPlan/detail/list", p, c)
  },
  teachPlan_detail_publish: {
    /*
     * 发布允许签到状态
     * ids IDs (array query required)
     * publishStatus 发布或未发布 (string query )
     */
    put: (p, c) => $.put("/api/ems/education/teachPlan/detail/publish", p, c)
  },
  teachPlan_detail_signatureForClient: {
    /*
     * 学生端-学生签到
     * id detail列表ID (integer query required)
     * signatureUrl 签到地址 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/teachPlan/detail/signatureForClient", p, c)
  },
  teachPlan_detail_update: {
    /*
     * 编辑
     * centreClassroomId 线下考点ID (integer query )
     * id ID (integer query required)
     * severalTimes 节数（数字） (integer query )
     * teachDate 上课日期 (string query )
     * timeFlag 上课时间（上午或下午） (string query )
     */
    put: (p, c) => $.put("/api/ems/education/teachPlan/detail/update", p, c)
  },
  teachPlan_detail_upload: {
    /*
     * 导入授课安排
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/education/teachPlan/detail/upload", p, c)
  },
  teachPlan_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/education/teachPlan/export", p, c)
  },
  teachPlan_initTeachPlan: {
    /*
     * 生成授课计划
     * centreClassrooms 教室ID列表 (array query required)
     * rollGrade 学籍年级 (string query required)
     * siteId 学校ID (integer query required)
     * teachDates 上课日期列表 (string query )
     * term 学期 (integer query )
     */
    post: (p, c) => $.post("/api/ems/education/teachPlan/initTeachPlan", p, c)
  },
  teachPlan_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/education/teachPlan/list", p, c)
  },
  teachPlan_randomAssignAdultTeacher: {
    /*
     * 随机分配授课老师
     * rollGrade 学籍年级 (string query required)
     * siteId 学校ID (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/teachPlan/randomAssignAdultTeacher", p, c)
  },
  teachPlan_update: {
    /*
     * 编辑
     * adultTeacherId 授课老师Id (integer query )
     * hours 课时（数字） (integer query )
     * id ID (integer query required)
     */
    put: (p, c) => $.put("/api/ems/education/teachPlan/update", p, c)
  },
  teachPlan_upload: {
    /*
     * 批量导入课时（模板为教学计划导出列表）
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/education/teachPlan/upload", p, c)
  },

  /**
   * 线下课打卡
   */
  teaching_offline_commitByAdminTeacher: {
    /*
     * 业务助手端打卡提交
     * id 扫码返回的ID (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/teaching/offline/commitByAdminTeacher", p, c)
  },
  teaching_offline_downloadMould: {
    /*
     * 下载批量导入线下课学生模板
     */
    get: (p, c) =>
      $.get("/api/ems/education/teaching/offline/downloadMould", p, c)
  },
  teaching_offline_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/education/teaching/offline/export", p, c)
  },
  teaching_offline_exportRecord: {
    /*
     * 线下课学生列表-学历教育-教学教务
     */
    get: (p, c) =>
      $.get("/api/ems/education/teaching/offline/exportRecord", p, c)
  },
  teaching_offline_exportRecordForService: {
    /*
     * 线下课学生列表-学历教育-教学教务
     */
    get: (p, c) =>
      $.get("/api/ems/education/teaching/offline/exportRecordForService", p, c)
  },
  teaching_offline_getScanInfo: {
    /*
     * 业务助手端扫码获取信息
     * id 扫码返回的ID (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/teaching/offline/getScanInfo", p, c)
  },
  teaching_offline_list: {
    /*
     * 线下课列表
     */
    get: (p, c) => $.get("/api/ems/education/teaching/offline/list", p, c)
  },
  teaching_offline_listForClient: {
    /*
     * c端预约-我的课程列表
     * signStatus 打卡状态 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/teaching/offline/listForClient", p, c)
  },
  teaching_offline_listName: {
    /*
     * 线下课安排名称列表
     * publishStatus 发布状态：已发布|未发布 (string query )
     */
    get: (p, c) => $.get("/api/ems/education/teaching/offline/listName", p, c)
  },
  teaching_offline_listRecord: {
    /*
     * 线下课学生列表-学历教育-教学教务
     */
    get: (p, c) => $.get("/api/ems/education/teaching/offline/listRecord", p, c)
  },
  teaching_offline_listRecordForService: {
    /*
     * 线下课学生列表-学历教育-服务管理
     */
    get: (p, c) =>
      $.get("/api/ems/education/teaching/offline/listRecordForService", p, c)
  },
  teaching_offline_publish: {
    /*
     * 发布
     * ids ids (array query required)
     * publishStatus 发布状态：已发布|未发布 (string query required)
     */
    post: (p, c) => $.post("/api/ems/education/teaching/offline/publish", p, c)
  },
  teaching_offline_remove: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/education/teaching/offline/remove", p, c)
  },
  teaching_offline_removeRecord: {
    /*
     * 删除线下课学生
     * ids 线下课学生列表返回的ids (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/education/teaching/offline/removeRecord", p, c)
  },
  teaching_offline_save: {
    /*
     * 添加编辑
     * id id (integer query )
     * name 名称 (string query required)
     * remark 备注 (string query )
     */
    post: (p, c) => $.post("/api/ems/education/teaching/offline/save", p, c)
  },
  teaching_offline_showScanInfo: {
    /*
     * 展示二维码调用
     * id 我的课程列表返回的ID (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/teaching/offline/showScanInfo", p, c)
  },
  teaching_offline_uploadStudent: {
    /*
     * 批量导入线下课学生
     * excelFile excelFile (file formData required)
     * id id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/teaching/offline/uploadStudent", p, c)
  },

  /**
   * 教学计划
   */
  teachingProgram: {
    /*
     * 添加
     * code 课程代码 (string query )
     * courseCategory 课程性质（公共课、专业课） (string query )
     * courseId 课程id (integer query )
     * credits 学分 (number query )
     * degreeCourseFlag 是否学位课（是否） (string query )
     * ebookId 电子书id (integer query )
     * examType 考核方式（考试、考查） (string query )
     * hours 课时，是文本 (string query )
     * id  (integer query )
     * majorId 专业id (integer query )
     * name 课程名字 (string query )
     * remark 备注 (string query )
     * rollGrade 学籍年级 (string query )
     * teachType 学习形式（面授、网络） (string query )
     * term 学期,0为考前辅导 (integer query )
     */
    post: (p, c) => $.post("/api/ems/education/teachingProgram", p, c),

    /*
     * 删除
     * id 教学计划id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/education/teachingProgram", p, c)
  },
  teachingProgram_batchRemove: {
    /*
     * 批量删除教学计划
     * ids 教学计划id列表 (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/education/teachingProgram/batchRemove", p, c)
  },
  teachingProgram_changeCourse: {
    /*
     * 批量更换资源课程
     * courseId 资源课程id (integer query required)
     * ids 列表ids (array query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/teachingProgram/changeCourse", p, c)
  },
  teachingProgram_changeEbook: {
    /*
     * 批量更换电子教材
     * ebookId 电子教材id (integer query required)
     * ids 列表ids (array query required)
     */
    put: (p, c) => $.put("/api/ems/education/teachingProgram/changeEbook", p, c)
  },
  teachingProgram_export: {
    /*
     * 教学计划导出
     */
    get: (p, c) => $.get("/api/ems/education/teachingProgram/export", p, c)
  },
  teachingProgram_list: {
    /*
     * 教学计划列表
     */
    get: (p, c) => $.get("/api/ems/education/teachingProgram/list", p, c)
  },
  teachingProgram_listBySchoolRollId: {
    /*
     * 根据合同编号查询教学计划列表,带电子书下载地址
     * schoolRollId 合同编号 (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/teachingProgram/listBySchoolRollId", p, c)
  },
  teachingProgram_listCourseForCurrentTerm: {
    /*
     * 当前学期课程列表
     * currentTerm 当前学期 (integer query required)
     * majorId 专业id (integer query required)
     * rollGrade 学习年级 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/teachingProgram/listCourseForCurrentTerm", p, c)
  },
  teachingProgram_listPlanByTerm: {
    /*
     * 每个学期的学习计划
     * majorId 专业id (integer query required)
     * rollGrade 学习年级 (string query required)
     * term 学期 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/teachingProgram/listPlanByTerm", p, c)
  },
  teachingProgram_listSimple: {
    /*
     * 简易列表
     * majorId 专业id (integer query )
     * rollGrade 学籍年级 (string query )
     * term 学期 (integer query )
     */
    get: (p, c) => $.get("/api/ems/education/teachingProgram/listSimple", p, c)
  },
  teachingProgram_listSimpleWithMultiple: {
    /*
     * 简易列表
     * majorIds 专业列表 (array query )
     * rollGrades 学籍年级列表 (array query )
     * siteIds 学校列表 (array query )
     * terms 学期列表 (array query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/teachingProgram/listSimpleWithMultiple", p, c)
  },
  teachingProgram_listStudyRecordForCurrentTerm: {
    /*
     * 当前学期最近记录
     * currentTerm 当前学期 (integer query required)
     * majorId 专业id (integer query required)
     * rollGrade 学习年级 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/teachingProgram/listStudyRecordForCurrentTerm",
        p,
        c
      )
  },
  teachingProgram_listTerm: {
    /*
     * 学期列表
     * currentTerm 当前学期 (integer query )
     * majorId 专业id (integer query required)
     * rollGrade 学籍年级 (string query required)
     */
    get: (p, c) => $.get("/api/ems/education/teachingProgram/listTerm", p, c)
  },
  teachingProgram_saveTextbook: {
    /*
     * 编辑教材
     * bookNo 书号 (string query required)
     * bookSeller 书商 (string query required)
     * discount 折扣 (number query required)
     * editor 主编 (string query required)
     * id 教学计划id (integer query required)
     * originPrice 原价 (number query required)
     * pressName 出版社 (string query required)
     * price 折后价 (number query required)
     * textbook 教材名称 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/teachingProgram/saveTextbook", p, c)
  },
  teachingProgram_upload: {
    /*
     * 批量上传（如果名字改变视为新的教学计划）
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/education/teachingProgram/upload", p, c)
  },
  teachingProgram_uploadForCheck: {
    /*
     * 导入验证教学计划
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/teachingProgram/uploadForCheck", p, c)
  }
};
